<template>
  <div class="user-management-wrapper">
    <!-- Overlay Background -->
    <v-overlay
      v-model="showSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9998"
    >
    </v-overlay>
    
    <!-- Success Toast -->
    <transition name="fade-slide">
      <output v-if="showSuccess" class="success-toast" style="position: fixed; top: 30px; left: 50%; transform: translateX(-50%); z-index: 9999;">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 14px; font-weight: 600;">{{ SuccessMessage }}</span>
      </output>
    </transition>

    <v-container fluid class="border mt-4 mx-2 mx-md-5 user-management-container" style="border-radius: 16px; padding: 24px; margin-bottom: 24px;">
      <v-toolbar class="bg-white subTitleStyle">
        <v-toolbar-title class="ms-0 page-title" style="font-size: 1.5rem;">{{
          $t("_ChatUserManagement")
        }}</v-toolbar-title>
        <v-spacer />
        <div class="action-controls flex-wrap">
              <!-- Template Button -->
              <v-btn
                id="button-downloadtemplate-usermanagement"
                color="info"
                class="control-btn template-btn"
                variant="text"
                size="small"
                density="comfortable"
                @click="flagTemplate = true"
              >
                <img src="@/assets/Icons/new_download.svg" alt="">
                <span class="btn-text">{{ $t("template") }}</span>
                <v-tooltip activator="parent" location="top">
                  {{ $t("downloadTemplate") }}
                </v-tooltip>
              </v-btn>

              <!-- Import Button -->
              <v-btn
                id="button-importtemplate-usermanagement"
                color="info"
                class="control-btn import-btn"
                variant="text"
                size="small"
                density="comfortable"
                @click="triggerFileUpload"
              >
              <img src="@/assets/Icons/new_file_import.svg" alt="">
                <span class="btn-text">{{ $t("import") }}</span>
                <v-tooltip activator="parent" location="top">
                  {{ $t("importFile") }}
                </v-tooltip>
              </v-btn>

              <!-- Hidden File Component -->
              <DragDropFile
                ref="fileUploader"
                :dialog="true"
                :DragDrop="false"
                :ShowListFile="false"
                :accept="accept"
                @filesUploaded="processUpload($event)"
                :allowType="[]"
                class="d-none"
              />

              <!-- Add User Button -->
              <v-btn
                id="button-add-usermanagement"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                rounded="xl"
                @click="
                  Adddialog = true;
                  mailcheck = false;
                  phonecheck = false;
                  GetModel(null);
                  GetGroupModel(null);
                  checkLengthPassword = true;
                  checkLowercaseLetter = true;
                  checkUppercaseLetter = true;
                  checkNumber = true;
                  checkSpecialCharacter = true;
                  checkPasswordMatch = true;
                  user.password = null;
                  user.confirmpassword = null;
                "
              >
                <img src="@/assets/Icons/new_round_plus.svg" alt="">
                <span class="btn-text">{{ $t("add") }}</span>
                <v-tooltip activator="parent" location="top">
                  {{ $t("addNewUser") }}
                </v-tooltip>
              </v-btn>
            </div>
      </v-toolbar>
      <v-card class="card2" style="margin-top: 24px; margin-bottom: 0px; padding-top: 0;">
        <v-card-text class="pa-0">
          <v-card variant="outlined" class="search-panel" style="padding: 24px !important;border: 1px solid var(--placeholder, #CCC) !important">
            <v-row>
              <v-col cols="12" md="9">
                <v-row >
                  <v-col cols="12" md="5">
                    <v-text-field
                      id="username-field-search-userchatmanagement"
                      class="userNameInput"
                      :placeholder="$t('username')"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      v-model="username"
                      @keydown.enter="Search"
                      color="primary"
                    >
                      <template #prepend-inner>
                        <img 
                          src="@/assets/Icons/new_search_outline.svg" 
                          alt="search" 
                          style="width:20px;height:20px;margin-right:8px;"
                        />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      id="email-field-search-userchatmanagement"
                      class="emailInput"
                      :placeholder="$t('email')"
                      v-model="email"
                      density="comfortable"
                      variant="outlined"
                      hide-details
                      @keydown.enter="Search"
                      color="primary"
                    >
                      <template #prepend-inner>
                        <img 
                          src="@/assets/Icons/new_search_outline.svg" 
                          alt="search" 
                          style="width:20px;height:20px;margin-right:8px;"
                        />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="1"
                    class="d-flex align-center"
                  >
                    <v-btn
                      color="primary"
                      class="rounded-circle pa-0"
                      style="
                        min-width: 40px !important; 
                        height: 40px;
                        background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%);
                      "
                      variant="elevated"
                      @click="Search"
                    >
                      <img src="@/assets/Icons/new_search_bold.svg" alt="">
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="1" class="d-none d-lg-block">
                <v-divider
                  vertical
                  thickness="2"
                  length="40"
                  style="background: #c9c9c9; opacity: 1;"
                ></v-divider>
              </v-col>
              <v-col cols="12" md="3" lg="2">
                <v-btn
                  class="control-btn sync-btn d-flex px-4"
                  variant="text"
                  size="small"
                  density="comfortable"
                  @click="SyncUser()"
                  style="min-width: 135px !important;"
                >
                  <template #prepend>
                    <img 
                      src="@/assets/Icons/new_sync_solid.svg" 
                      alt="sync" 
                      style="width:20px;height:20px;"
                    />
                  </template>
                  <span class="btn-text" style="text-transform: none !important;">{{ $t("syncUsers") }}</span>
                  <v-tooltip activator="parent" location="top" width="300">
                    {{ $t("syncUsersTooltip") }}
                  </v-tooltip>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-data-table-server
          :items="filteredUsers"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :headers="headers"
          :loading="loadingTable"
          style="margin-top: 24px"
        >
          <template v-slot:no-data>
            <div class="no-data-placeholder"><span style="color: grey">{{(!username && !email) ? '' : 'Searching '}}</span>{{ noDataMessage }}</div>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td class="table-cell text-center">{{ item.number }}</td>
              <td class="table-cell">{{ item.username }}</td>
              <td class="table-cell">{{ item.email }}</td>
              <td class="table-cell">{{ item.mobile }}</td>
              <td class="table-cell">{{ item.fullName }}</td>
              <td class="table-cell" style="text-align: center">
                <div class="action-group" style="justify-content: center; gap: 16px;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-userchatmanagement"
                    variant="text"
                    density="comfortable"
                    @click="EditUser(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <img src="@/assets/Icons/new_edit.svg" alt="">
                    <v-tooltip activator="parent" location="top">
                      {{$t("edit")}}
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->

                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupdelete-userchatmanagement"
                    variant="text"
                    density="comfortable"
                    @click="openDeleteDialog(item)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <img src="@/assets/Icons/new_delete.svg" alt="">
                    <v-tooltip activator="parent" location="top">
                      {{$t("delete")}}
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4"
              style="width: 100%; margin-top: 24px;"
            >
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                class="pa-0"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>

      </v-card>
    </v-container>
    <!-- EditUserDialog -->
    <v-dialog
      v-model="Editdialog"
      max-width="900px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit ml-5 pt-4 pb-2">
          <div class="header-main">
            <div class="header-text-container">
              <h2 class="dialog-title mb-0">{{ $t("editChatUser") }}</h2>
              <p>
                {{ $t("editChatUserDescription") }}
              </p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="edit-user-content">
          <v-container fluid class="px-0">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_ui_link.svg" class="mr-2" alt="">
                {{ $t("basicInfo") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label" for="username-field-edit-userchatmanagement">{{ $t("usernameReadonly") }}</label>
                    <v-text-field
                      id="username-field-edit-userchatmanagement"
                      v-model="edit.username"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      disabled
                      :placeholder="$t('_enterUsername')"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="firstname-field-popupedit-userchatmanagement">{{ $t("firstname") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="firstname-field-popupedit-userchatmanagement"
                      v-model="edit.firstname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('_enterFirstName')"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="lastname-field-popupedit-userchatmanagement">{{ $t("lastname") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="lastname-field-popupedit-userchatmanagement"
                      v-model="edit.lastname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('_enterLastName')"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="email-field-edit-userchatmanagement">{{ $t("email") }} {{ !edit.isUserFromLine ? "" : "(Read Only)" }} <span style="color: #CC1F47" v-if="!edit.isUserFromLine">*</span></label>
                    <v-text-field
                      id="email-field-edit-userchatmanagement"
                      v-model="edit.email"
                      :rules="emailRules"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :disabled="!edit.isUserFromLine"
                      placeholder="example@email.com"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="phonenumber-field-popupedit-userchatmanagement">{{ $t("phonenumber") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="phonenumber-field-popupedit-userchatmanagement"
                      v-model="edit.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="09123456789"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Integration Social Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_network_chart.svg" class="mr-2" alt="">
                {{ $t("integrationSocial") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="socialuserid-line-field-edit-userchatmanagement">{{ $t("socialUserID") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("socialUserIDTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="socialuserid-line-field-edit-userchatmanagement"
                      :placeholder="$t('SocialUserID')"
                      v-model="edit.socialUserID"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="recipientId-facebook-field-edit-userchatmanagement">{{$t("recipientIdFB")}}</label>
                      <v-tooltip location="top start">
                        {{ $t("recipientIdFBTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="recipientId-facebook-field-edit-userchatmanagement"
                      :placeholder="$t('RecipientId')"
                      v-model="edit.recipientId"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="recipientId-instagram-field-edit-userchatmanagement">{{ $t("recipientIdIG") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("recipientIdIGTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="recipientId-instagram-field-edit-userchatmanagement"
                      :placeholder="$t('RecipientId_Instagram')"
                      v-model="edit.recipientId_Instagram"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Model Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_ai_duotone.svg" class="mr-2" alt="">
                {{ $t("modelConfiguration") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="modelgrouping-autocomplete-userchatmanagement">{{ $t("modelGrouping") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("modelGroupingTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-autocomplete
                      id="modelgrouping-autocomplete-userchatmanagement"
                      :placeholder="$t('SelectModelGrouping')"
                      :items="listDDGroupModel"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="edit.groupModel"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelgrouping-edit-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="model-autocomplete-edit-userchatmanagement">{{$t("model")}}</label>
                      <v-tooltip location="top start">
                        {{ $t("modelTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-autocomplete
                      id="model-autocomplete-edit-userchatmanagement"
                      ref="modelEdit"
                      :placeholder="$t('selectModels')"
                      :items="listDDModel"
                      chips
                      :closable-chips="allModelsSelectedEdit ? false : true"
                      item-title="name"
                      item-value="modelDisplayID"
                      multiple
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="edit.model"
                      class="modern-input modern-autocomplete"
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-if="allModelsSelectedEdit && edit.model?.indexOf(item.raw.modelDisplayID) === 0"
                          v-bind="props"
                          color="error"
                          variant="tonal"
                          size="small"
                          class="model-chip"
                          @click:close="deselectAllModelsEdit"
                        >
                          {{ $t('_allModelsLabel') }}
                          <v-tooltip location="top start">
                            {{ $t('_allAvailableModelsIncluded') }}
                            <template #activator="{ props }">
                              <v-icon
                                v-bind="props"
                                size="20"
                                class="info-icon ml-1"
                                color="grey"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                          </v-tooltip>
                        </v-chip>
                        <v-chip
                          v-else-if="!allModelsSelectedEdit"
                          v-bind="props"
                          :text="item.raw.name"
                          color="error"
                          variant="tonal"
                          size="small"
                          closable
                          class="model-chip"
                        >
                        </v-chip>
                      </template>
                      
                      <template v-slot:prepend-item>
                        <v-list-item
                          @click="toggleAllModelsEdit"
                          class="all-models-item"
                          :class="{ 'selected': allModelsSelectedEdit }"
                        >
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :model-value="allModelsSelectedEdit"
                              :indeterminate="someModelsSelectedEdit"
                              color="error"
                            ></v-checkbox-btn>
                          </template>
                          <v-list-item-title>
                            {{ $t('_allModelsLabel') }}
                            <v-tooltip location="top start">
                              {{ $t('_allAvailableModelsIncluded') }}
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="20"
                                  class="info-icon"
                                  color="grey"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                            </v-tooltip>
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                      </template>
                      
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'model-edit-userchatmanagement-option-' + index" 
                          class="autocomplete-item"
                        >
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :model-value="edit.model?.includes(item.raw.modelDisplayID) ?? false"
                              color="error"
                            ></v-checkbox-btn>
                          </template>
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="modelshortcut-autocomplete-edit-userchatmanagement">{{ $t("modelShortcut") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("modelShortcutTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-autocomplete
                      id="modelshortcut-autocomplete-edit-userchatmanagement"
                      :placeholder="$t('selectModelShortcut')"
                      :items="DDQuickModel"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="edit.modelQuickGroupID"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelshortcut-edit-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Lock Status Section -->
            <div class="form-section mb-0">
              <div class="section-title">
                <img src="@/assets/Icons/new_user_guard.svg" class="mr-2" alt="">
                {{ $t("accountSettings") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="switch-div">
                    <div class="switch-content-div">
                      <div class="switch-info">
                        <div>
                          <div class="label-with-icon">
                            <label class="input-label" style="font-size: 18px; font-weight: 600;" for="switch-lockstatus-popupedit-userchatmanagement">{{ $t("lockStatus") }}</label>
                            <v-tooltip location="top start">
                              {{ $t("lockStatusTooltip") }}
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="18"
                                  class="info-icon"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                            </v-tooltip>
                          </div>
                          <div class="switch-subtitle" style="color: var(--Gray-Text, #646464); font-size: 16px;">
                            {{
                              edit.lockStatus
                                ? $t("lockStatusLocked")
                                : $t("lockStatusUnlocked")
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control-div">
                        <v-switch
                          id="switch-lockstatus-popupedit-userchatmanagement"
                          v-model="edit.lockStatus"
                          color="error"
                          hide-details
                          inset
                          class="modern-switch mb-3"
                        >
                        </v-switch>
                        <span
                          class="switch-label"
                          :class="{
                            'locked-text': edit.lockStatus,
                            'unlocked-text': !edit.lockStatus,
                          }"
                        >
                          {{
                            edit.lockStatus
                              ? $t("_Locked")
                              : $t("_Unlocked")
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Quota & Usage Limits Section (Edit) -->
            <div class="form-section mb-0">
              <div class="section-title">
                <span class="mr-2" style="display:inline-flex; align-items:center; color:#c32e0e; width:20px; height:20px; flex-shrink:0;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 12V3h-1a10 10 0 1 0 10 10v-1Z" />
                    <path fill="currentColor" d="M14 10V1a9 9 0 0 1 9 9Z" />
                  </svg>
                </span>
                {{ $t('_quotaUsageLimits') }}
              </div>

              <!-- Token Quota -->
              <v-row class="form-row" dense>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label d-flex align-center" for="token-quota-field-edit-userchatmanagement">
                      {{ $t('tokenQuota') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_maxCumulativeTokens') }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      id="token-quota-field-edit-userchatmanagement"
                      v-model.number="edit.userTokenLimit"
                      type="number"
                      min="1"
                      :disabled="edit.userUnlimitedToken"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input mt-1"
                      :placeholder="$t('_enterTokenQuota')"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-checkbox
                    v-model="edit.userUnlimitedToken"
                    hide-details
                    color="primary"
                    class="mt-4"
                    @update:modelValue="edit.userUnlimitedToken ? (edit.userTokenLimit = null) : null"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <span>{{ $t('_UnlimitedToken') }}</span>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_enableUnlimitedToken') }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <!-- Token Usage Indicator (Edit only) -->
              <v-row v-if="!edit.userUnlimitedToken && edit.userTokenLimit" dense class="mt-1 mb-2">
                <v-col cols="12">
                  <div class="user-quota-indicator-row">
                    <div class="user-quota-card" :style="{ background: (edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? '#FFF1F1' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? '#FFFBEB' : '#F0FDF4', border: '1px solid ' + ((edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? '#FCA5A5' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? '#FCD34D' : '#86EFAC'), borderRadius: '8px', padding: '8px 12px' }">
                      <div class="d-flex align-center justify-space-between mb-1">
                        <div class="d-flex align-center" style="gap:6px;">
                          <v-icon size="16" :color="(edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? '#DC2626' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? '#D97706' : '#16A34A'">
                            {{ (edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? 'mdi-alert-circle' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? 'mdi-alert' : 'mdi-check-circle' }}
                          </v-icon>
                          <span :style="{ fontSize: '12px', fontWeight: 600, color: (edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? '#DC2626' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? '#D97706' : '#16A34A' }">
                            {{ (edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? 'Quota Exhausted' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? 'Quota Nearly Full' : 'Quota Usage' }}
                          </span>
                        </div>
                        <span style="font-size:12px; color:#374151; font-weight:500;">{{ (edit.userTokenUsage ?? 0).toLocaleString() }} / {{ edit.userTokenLimit.toLocaleString() }} tokens ({{ Math.min(Math.round(((edit.userTokenUsage ?? 0) / edit.userTokenLimit) * 100), 100) }}%)</span>
                      </div>
                      <div class="user-quota-progress-row">
                        <v-progress-linear
                          class="user-quota-progress"
                          :model-value="Math.min(((edit.userTokenUsage ?? 0) / edit.userTokenLimit) * 100, 100)"
                          :color="(edit.userTokenUsage ?? 0) >= edit.userTokenLimit ? '#DC2626' : (edit.userTokenUsage ?? 0) / edit.userTokenLimit >= 0.8 ? '#D97706' : '#16A34A'"
                          bg-color="#E5E7EB"
                          height="8"
                          rounded
                        ></v-progress-linear>
                      </div>
                    </div>
                    <v-btn
                      icon
                      type="button"
                      variant="flat"
                      size="small"
                      class="user-reset-button"
                      :loading="isUserQuotaResetting(edit, 'token')"
                      :disabled="isUserQuotaResetting(edit, 'token')"
                      @click.stop="resetUserQuota(edit, 'token')"
                    >
                      <span class="user-reset-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path fill="currentColor" d="M12 20q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4q1.725 0 3.3.712T18 6.75V5q0-.425.288-.712T19 4t.713.288T20 5v5q0 .425-.288.713T19 11h-5q-.425 0-.712-.288T13 10t.288-.712T14 9h3.2q-.8-1.4-2.187-2.2T12 6Q9.5 6 7.75 7.75T6 12t1.75 4.25T12 18q1.7 0 3.113-.862t2.187-2.313q.2-.35.563-.487t.737-.013q.4.125.575.525t-.025.75q-1.025 2-2.925 3.2T12 20" />
                        </svg>
                      </span>
                      <v-tooltip activator="parent" location="top">{{ $t('_ResetToken') }}</v-tooltip>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <!-- Image Credit Limit -->
              <v-row class="form-row" dense>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label d-flex align-center" for="image-credit-field-edit-userchatmanagement">
                      {{ $t('imageCreditLimit') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_maxImagesGenerate') }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      id="image-credit-field-edit-userchatmanagement"
                      v-model.number="edit.userImageLimit"
                      type="number"
                      min="1"
                      :disabled="edit.userUnlimitedImage"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input mt-1"
                      :placeholder="$t('_enterImageCreditLimit')"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-checkbox
                    v-model="edit.userUnlimitedImage"
                    hide-details
                    color="primary"
                    class="mt-4"
                    @update:modelValue="edit.userUnlimitedImage ? (edit.userImageLimit = null) : null"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <span>{{ $t('_unlimitedImageCredit') }}</span>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_enableUnlimitedImage') }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <!-- Image Usage Indicator (Edit only) -->
              <v-row v-if="!edit.userUnlimitedImage && edit.userImageLimit" dense class="mt-1 mb-2">
                <v-col cols="12">
                  <div class="user-quota-indicator-row">
                    <div class="user-quota-card" :style="{ background: (edit.userImageUsage ?? 0) >= edit.userImageLimit ? '#FFF1F1' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? '#FFFBEB' : '#F0FDF4', border: '1px solid ' + ((edit.userImageUsage ?? 0) >= edit.userImageLimit ? '#FCA5A5' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? '#FCD34D' : '#86EFAC'), borderRadius: '8px', padding: '8px 12px' }">
                      <div class="d-flex align-center justify-space-between mb-1">
                        <div class="d-flex align-center" style="gap:6px;">
                          <v-icon size="16" :color="(edit.userImageUsage ?? 0) >= edit.userImageLimit ? '#DC2626' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? '#D97706' : '#16A34A'">
                            {{ (edit.userImageUsage ?? 0) >= edit.userImageLimit ? 'mdi-alert-circle' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? 'mdi-alert' : 'mdi-check-circle' }}
                          </v-icon>
                          <span :style="{ fontSize: '12px', fontWeight: 600, color: (edit.userImageUsage ?? 0) >= edit.userImageLimit ? '#DC2626' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? '#D97706' : '#16A34A' }">
                            {{ (edit.userImageUsage ?? 0) >= edit.userImageLimit ? 'Credit Exhausted' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? 'Credit Nearly Full' : 'Credit Usage' }}
                          </span>
                        </div>
                        <span style="font-size:12px; color:#374151; font-weight:500;">{{ (edit.userImageUsage ?? 0).toLocaleString() }} / {{ edit.userImageLimit.toLocaleString() }} images ({{ Math.min(Math.round(((edit.userImageUsage ?? 0) / edit.userImageLimit) * 100), 100) }}%)</span>
                      </div>
                      <div class="user-quota-progress-row">
                        <v-progress-linear
                          class="user-quota-progress"
                          :model-value="Math.min(((edit.userImageUsage ?? 0) / edit.userImageLimit) * 100, 100)"
                          :color="(edit.userImageUsage ?? 0) >= edit.userImageLimit ? '#DC2626' : (edit.userImageUsage ?? 0) / edit.userImageLimit >= 0.8 ? '#D97706' : '#16A34A'"
                          bg-color="#E5E7EB"
                          height="8"
                          rounded
                        ></v-progress-linear>
                      </div>
                    </div>
                    <v-btn
                      icon
                      type="button"
                      variant="flat"
                      size="small"
                      class="user-reset-button"
                      :loading="isUserQuotaResetting(edit, 'image')"
                      :disabled="isUserQuotaResetting(edit, 'image')"
                      @click.stop="resetUserQuota(edit, 'image')"
                    >
                      <span class="user-reset-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path fill="currentColor" d="M12 20q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4q1.725 0 3.3.712T18 6.75V5q0-.425.288-.712T19 4t.713.288T20 5v5q0 .425-.288.713T19 11h-5q-.425 0-.712-.288T13 10t.288-.712T14 9h3.2q-.8-1.4-2.187-2.2T12 6Q9.5 6 7.75 7.75T6 12t1.75 4.25T12 18q1.7 0 3.113-.862t2.187-2.313q.2-.35.563-.487t.737-.013q.4.125.575.525t-.025.75q-1.025 2-2.925 3.2T12 20" />
                        </svg>
                      </span>
                      <v-tooltip activator="parent" location="top">{{ $t('_ResetImageCredit') }}</v-tooltip>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <!-- Token Reset Period -->
              <v-row class="form-row" dense>
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label d-flex align-center" for="token-reset-period-select-edit-userchatmanagement">
                      {{ $t('_TokenResetPeriod') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_autoResetUsage') }}</span>
                      </v-tooltip>
                    </label>
                    <v-select
                      id="token-reset-period-select-edit-userchatmanagement"
                      v-model="edit.userResetDays"
                      :items="userResetDaysOptions"
                      item-title="text"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input mt-1"
                      :placeholder="$t('_selectResetPeriod')"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="edit-user-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-btn
                id="button-changepassword-popupedit-userchatmanagement"
                variant="outlined"
                @click="
                  changPasswordDialog = true;
                  edit.password = null;
                  edit.confirmpassword = null;
                  checkLengthPassword = true;
                  checkLowercaseLetter = true;
                  checkUppercaseLetter = true;
                  checkNumber = true;
                  checkSpecialCharacter = true;
                  checkPasswordMatch = true;
                "
                class="dialog-action-btn changePassword-btn"
              >
                <img src="@/assets/Icons/new_reset_password.png" alt="icon" class="mr-2" />
                {{ $t("changePassword") }}
              </v-btn>
            </div>
            <div class="actions-right">
              <v-spacer></v-spacer>
              <v-btn
                variant="outlined"
                color="grey"
                @click="Editdialog = false"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>
              <v-btn
                id="button-save-popupedit-userchatmanagement"
                variant="elevated"
                @click="UpdateUser"
                class="dialog-action-btn save-btn-edit"
              >
                <img src="@/assets/Icons/new_save_floppy.svg" class="mr-2" alt="Save">
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AddUserDialog -->
    <v-dialog
      ref="form"
      v-model="Adddialog"
      max-width="900px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-add ml-5 pt-4 pb-2">
          <div class="header-main">
            <div class="header-text-container">
              <h2 class="dialog-title mb-0">{{ $t("addChatUser") }}</h2>
              <p>
                {{ $t("addChatUserDescription") }}
              </p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="add-user-content">
          <v-container fluid class="px-0">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_ui_link.svg" class="mr-2" alt="">
                {{ $t("basicInfo") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label" for="username-field-add-userchatmanagement">{{ $t("username") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="username-field-add-userchatmanagement"
                      ref="username"
                      v-model="user.username"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('_enterUsername')"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("username") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="firstname-field-add-userchatmanagement">{{ $t("firstname") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="firstname-field-add-userchatmanagement"
                      ref="firstname"
                      v-model="user.firstname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('_enterFirstName')"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="lastname-field-add-userchatmanagement">{{ $t("lastname") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="lastname-field-add-userchatmanagement"
                      ref="lastname"
                      v-model="user.lastname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('_enterLastName')"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="email-field-add-userchatmanagement">{{ $t("email") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="email-field-add-userchatmanagement"
                      ref="email"
                      v-model="user.email"
                      :rules="[rules.required, validateEmail(user.email)]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="example@email.com"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="phone-field-add-userchatmanagement">{{ $t("phonenumber") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="phone-field-add-userchatmanagement"
                      ref="phone"
                      v-model="user.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="09123456789"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Password Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_lock.svg" class="mr-2" alt="">
                {{ $t("pwdSetup") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="password-field-add-userchatmanagement">{{ $t("loginPwd") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="password-field-add-userchatmanagement"
                      ref="password"
                      v-model="user.password"
                      :rules="[rules.required]"
                      :type="show1 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('password')"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show1 = !show1"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show1 ? "mdi-lock-open" : "mdi-lock-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements -->
                    <div class="password-requirements" v-if="user.password">
                      <div
                        class="requirement-item"
                        :class="{ valid: checkLengthPassword }"
                      >
                        <v-icon
                          size="12"
                          :color="checkLengthPassword ? 'success' : 'error'"
                        >
                          {{ checkLengthPassword ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("pwdLength") }}</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkLowercaseLetter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkLowercaseLetter ? 'success' : 'error'"
                        >
                          {{ checkLowercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("pwdLowercase") }}</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkUppercaseLetter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkUppercaseLetter ? 'success' : 'error'"
                        >
                          {{ checkUppercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("pwdUppercase") }}</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkNumber }"
                      >
                        <v-icon
                          size="12"
                          :color="checkNumber ? 'success' : 'error'"
                        >
                          {{ checkNumber ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("pwdNumber") }}</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkSpecialCharacter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkSpecialCharacter ? 'success' : 'error'"
                        >
                          {{
                            checkSpecialCharacter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>{{ $t("pwdSpecialChar") }}</span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="confirmpassword-field-add-userchatmanagement">{{ $t("confirmPwd") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="confirmpassword-field-add-userchatmanagement"
                      ref="confirmpassword"
                      v-model="user.confirmpassword"
                      :rules="[rules.required]"
                      :type="show2 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :placeholder="$t('confirmPassword')"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show2 = !show2"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show2 ?  "mdi-lock-open" : "mdi-lock-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator -->
                    <div class="password-match" v-if="user.confirmpassword">
                      <div
                        class="requirement-item"
                        :class="{ valid: checkPasswordMatch }"
                      >
                        <v-icon
                          size="12"
                          :color="checkPasswordMatch ? 'success' : 'error'"
                        >
                          {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("pwdMatch") }}</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Integration Social Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_network_chart.svg" class="mr-2" alt="">
                {{$t("integrationSocial")}}
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="socialUserID-line-field-add-userchatmanagement">{{$t("socialUserID")}}</label>
                      <v-tooltip location="top start">
                        {{ $t("socialUserIDTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="socialUserID-line-field-add-userchatmanagement"
                      ref="socialUserID"
                      :placeholder="$t('SocialUserID')"
                      v-model="user.socialUserID"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="recipientId-facebook-field-add-userchatmanagement">{{ $t("recipientIdFB") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("recipientIdFBTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="recipientId-facebook-field-add-userchatmanagement"
                      ref="recipientId"
                      :placeholder="$t('RecipientId')"
                      v-model="user.recipientId"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="recipientId-instagram-field-add-userchatmanagement">{{ $t("recipientIdIG") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("recipientIdIGTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="recipientId-instagram-field-add-userchatmanagement"
                      ref="recipientId_Instagram"
                      :placeholder="$t('RecipientId_Instagram')"
                      v-model="user.recipientId_Instagram"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Model Section -->
            <div class="form-section">
              <div class="section-title">
                <img src="@/assets/Icons/new_ai_duotone.svg" class="mr-2" alt="">
                {{ $t("modelConfiguration") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="modelGrouping-autocomplete-add-userchatmanagement">{{ $t("modelGrouping") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("modelGroupingTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-autocomplete
                      id="modelGrouping-autocomplete-add-userchatmanagement"
                      ref="groupModel"
                      :placeholder="$t('selectModelGrouping')"
                      :items="listDDGroupModel"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="user.groupModel"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelgrouping-add-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="model-autocomplete-add-userchatmanagement">{{ $t("model") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("modelTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-autocomplete
                      id="model-autocomplete-add-userchatmanagement"
                      ref="model"
                      :placeholder="$t('selectModels')"
                      :items="listDDModel"
                      chips
                      :closable-chips="allModelsSelectedAdd ? false : true"
                      item-title="name"
                      item-value="modelDisplayID"
                      multiple
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="user.model"
                      class="modern-input modern-autocomplete"
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-if="allModelsSelectedAdd && user.model?.indexOf(item.raw.modelDisplayID) === 0"
                          v-bind="props"
                          color="error"
                          variant="tonal"
                          size="small"
                          class="model-chip"
                          @click:close="deselectAllModelsAdd"
                        >
                          {{ $t('_allModelsLabel') }}
                          <v-tooltip location="top start">
                            {{ $t('_allAvailableModelsIncluded') }}
                            <template #activator="{ props }">
                              <v-icon
                                v-bind="props"
                                size="20"
                                class="info-icon ml-2"
                                color="grey"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                          </v-tooltip>
                        </v-chip>
                        <v-chip
                          v-else-if="!allModelsSelectedAdd"
                          v-bind="props"
                          :text="item.raw.name"
                          color="error"
                          variant="tonal"
                          size="small"
                          closable
                          class="model-chip"
                        >
                        </v-chip>
                      </template>
                      
                      <template v-slot:prepend-item>
                        <v-list-item
                          @click="toggleAllModelsAdd"
                          class="all-models-item"
                          :class="{ 'selected': allModelsSelectedAdd }"
                        >
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :model-value="allModelsSelectedAdd"
                              :indeterminate="someModelsSelectedAdd"
                              color="error"
                            ></v-checkbox-btn>
                          </template>
                          <v-list-item-title>
                            {{ $t('_allModelsLabel') }}
                            <v-tooltip location="top start">
                              {{ $t('_allAvailableModelsIncluded') }}
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="20"
                                  class="info-icon"
                                  color="grey"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                            </v-tooltip>
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                      </template>
                      
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'model-add-userchatmanagement-option-' + index" 
                          class="autocomplete-item"
                        >
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :model-value="user.model?.includes(item.raw.modelDisplayID) ?? false"
                              color="error"
                            ></v-checkbox-btn>
                          </template>
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="label-with-icon">
                      <label class="input-label" for="modelShortcut-autocomplete-add-userchatmanagement">{{ $t("modelShortcut") }}</label>
                      <v-tooltip location="top start">
                        {{ $t("modelShortcutTooltip") }}
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="18"
                            class="info-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </div>
                    <v-autocomplete
                      id="modelShortcut-autocomplete-add-userchatmanagement"
                      ref="modelQuickGroupID"
                      :placeholder="$t('selectModelShortcut')"
                      :items="DDQuickModel"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="user.modelQuickGroupID"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelshortcut-add-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
            </div>


            <!-- Lock Status Section -->
            <div class="form-section mb-0">
              <div class="section-title">
                <img src="@/assets/Icons/new_user_guard.svg" class="mr-2" alt="">
                {{ $t("accountSettings") }}
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="switch-div">
                    <div class="switch-content-div">
                      <div class="switch-info">
                        <div>
                          <div class="label-with-icon">
                            <label class="input-label" style="font-size: 18px; font-weight: 600;" for="switch-lockstatus-add-userchatmanagement">{{ $t("lockStatus") }}</label>
                            <v-tooltip location="top start">
                              {{ $t("lockStatusTooltip") }}
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="18"
                                  class="info-icon"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                            </v-tooltip>
                          </div>
                          <div class="switch-subtitle" style="color: var(--Gray-Text, #646464); font-size: 16px;">
                            {{
                              user.lockStatus
                                ? $t("newLockStatusLocked")
                                : $t("newLockStatusUnlocked")
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control-div">
                        <v-switch
                          id="switch-lockstatus-add-userchatmanagement"
                          v-model="user.lockStatus"
                          color="error"
                          hide-details
                          inset
                          class="modern-switch mb-3"
                        >
                        </v-switch>
                        <span
                          class="switch-label"
                          :class="{
                            'locked-text': user.lockStatus,
                            'unlocked-text': !user.lockStatus,
                          }"
                        >
                          {{
                            user.lockStatus
                              ? $t("_Locked")
                              : $t("_Unlocked")
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Quota & Usage Limits Section (Add) -->
            <div class="form-section mb-0">
              <div class="section-title">
                <span class="mr-2" style="display:inline-flex; align-items:center; color:#c32e0e; width:20px; height:20px; flex-shrink:0;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 12V3h-1a10 10 0 1 0 10 10v-1Z" />
                    <path fill="currentColor" d="M14 10V1a9 9 0 0 1 9 9Z" />
                  </svg>
                </span>
                {{ $t('_quotaUsageLimits') }}
              </div>

              <!-- Token Quota -->
              <v-row class="form-row" dense>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label d-flex align-center" for="token-quota-field-add-userchatmanagement">
                      {{ $t('tokenQuota') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_maxCumulativeTokens') }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      id="token-quota-field-add-userchatmanagement"
                      v-model.number="user.userTokenLimit"
                      type="number"
                      min="1"
                      :disabled="user.userUnlimitedToken"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input mt-1"
                      :placeholder="$t('_enterTokenQuota')"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-checkbox
                    v-model="user.userUnlimitedToken"
                    hide-details
                    color="primary"
                    class="mt-4"
                    @update:modelValue="user.userUnlimitedToken ? (user.userTokenLimit = null) : null"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <span>{{ $t('_UnlimitedToken') }}</span>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_enableUnlimitedToken') }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <!-- Image Credit Limit -->
              <v-row class="form-row" dense>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label d-flex align-center" for="image-credit-field-add-userchatmanagement">
                      {{ $t('imageCreditLimit') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_maxImagesGenerate') }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      id="image-credit-field-add-userchatmanagement"
                      v-model.number="user.userImageLimit"
                      type="number"
                      min="1"
                      :disabled="user.userUnlimitedImage"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input mt-1"
                      :placeholder="$t('_enterImageCreditLimit')"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-checkbox
                    v-model="user.userUnlimitedImage"
                    hide-details
                    color="primary"
                    class="mt-4"
                    @update:modelValue="user.userUnlimitedImage ? (user.userImageLimit = null) : null"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <span>{{ $t('_unlimitedImageCredit') }}</span>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_enableUnlimitedImage') }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <!-- Token Reset Period -->
              <v-row class="form-row" dense>
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label d-flex align-center" for="token-reset-period-select-add-userchatmanagement">
                      {{ $t('_TokenResetPeriod') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1" size="16">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_autoResetUsage') }}</span>
                      </v-tooltip>
                    </label>
                    <v-select
                      id="token-reset-period-select-add-userchatmanagement"
                      v-model="user.userResetDays"
                      :items="userResetDaysOptions"
                      item-title="text"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input mt-1"
                      :placeholder="$t('_selectResetPeriod')"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>


        <v-card-actions class="add-user-actions">
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-add-userchatmanagement"
            variant="outlined"
            color="grey"
            @click="closeadd"
            class="dialog-action-btn cancel-btn"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            id="button-save-add-userchatmanagement"
            variant="elevated"
            @click="AddUser"
            class="dialog-action-btn save-btn-add"
          >
            <img src="@/assets/Icons/new_save_floppy.svg" class="mr-2" alt="Save">
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Please Wait --> 
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="flagTemplate" max-width="900px" persistent>
      <v-card class="template-dialog">
        <v-card-title class="template-header">
          <div class="header-content">
            <div class="header-text">
              <h2 class="dialog-title">{{ $t("downloadTemplate") }}</h2>
              <p class="dialog-subtitle">
                {{ $t("downloadTemplateDescription") }}
              </p>
            </div>
          </div>
          <v-btn
            icon
            variant="text"
            size="small"
            @click="flagTemplate = false"
            class="close-btn"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="template-content">
              <div class="alert-content">
                <strong>{{ $t("howToUseTemplates") }}</strong>
                <ul class="template-instructions" style="padding-left: 16px !important;">
                  <li>{{ $t("templateStep1") }}</li>
                  <li>{{ $t("templateStep2") }}</li>
                  <li>
                    {{ $t("templateStep3") }}
                  </li>
                  <li>{{ $t("templateStep4") }}</li>
                </ul>
              </div>
           
          <div class="fileFormatDiv">
            <div class="d-flex">
              <img src="@/assets/Icons/new_memory_format_text.svg" alt="file-icon" class="mr-3"/>
              <h2 style="font-size: 22px !important; font-weight: 600 !important;">{{ $t("fileFormat") }}</h2>
            </div>
            <div class="d-flex mt-4">
              <div class="file-item mr-5">
                <v-btn class="file-icon" @click="linkDownload('CSV')">
                  <img src="@/assets/Icons/new_csv.svg" alt="CSV" />
                  <v-tooltip activator="parent" location="top">
                    {{ $t("CSVTooltip") }}
                  </v-tooltip>
                </v-btn>
                <span>CSV</span>
              </div>
              <div class="file-item ml-5">
                <v-btn class="file-icon" @click="linkDownload('Excel')">
                  <img src="@/assets/Icons/new_excel.svg" alt="Excel" />
                  <v-tooltip activator="parent" location="top">
                    {{ $t("ExcelTooltip") }}
                  </v-tooltip>
                </v-btn>
                <span>Excel</span>
              </div>
            </div>
          </div>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!--dialog change password-->
    <v-dialog
      v-model="changPasswordDialog"
      max-width="700px"
      persistent
      class="modern-dialog"
    >
      <v-card class="template-dialog">
        <v-card-title class="template-header">
          <div class="header-content">
            <div class="header-text">
              <h2 class="dialog-title">{{ $t("changePassword") }}</h2>
              <p class="dialog-subtitle">
                {{ $t("newPwdDescription") }}
              </p>
            </div>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="template-content">
          <!-- Security Tips -->
          <div class="alert-content">
            <strong>{{ $t("securityTips") }}</strong>
            <ul class="template-instructions" style="padding-left: 16px !important;">
              <li>{{ $t("securityStep1") }}</li>
              <li>
                {{ $t("securityStep2") }}
              </li>
              <li>
                {{ $t("securityStep3") }}
              </li>
              <li>{{ $t("securityStep4") }}</li>
            </ul>
          </div>

          <!-- Password Setup Section -->
          <div class="fileFormatDiv">
            <div class="d-flex">
              <img src="@/assets/Icons/new_lock.svg" alt="password-icon" class="mr-3"/>
              <h2 style="font-size: 22px !important; font-weight: 600 !important;">{{ $t("pwdSetup") }}</h2>
            </div>
            <v-container fluid class="mt-4">

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="password-field-popupedit-userchatmanagement">{{ $t("newPassword") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="password-field-popupedit-userchatmanagement"
                      ref="passwordChange"
                      :placeholder="$t('loginPwd')"
                      :rules="[rules.required]"
                      v-model="edit.password"
                      :type="show3 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show3 = !show3"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show3 ? "mdi-lock-open" : "mdi-lock-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements with Animation -->
                    <transition name="slide-fade" mode="out-in">
                      <div
                        class="password-requirements"
                        v-if="edit.password"
                        key="requirements"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLengthPassword }"
                        >
                          <v-icon
                            size="12"
                            :color="checkLengthPassword ? 'success' : 'error'"
                          >
                            {{
                              checkLengthPassword ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checklengthcharacters") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLowercaseLetter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkLowercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkLowercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checklowercaseletter") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkUppercaseLetter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkUppercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkUppercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checkuppercaseletter") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkNumber }"
                        >
                          <v-icon
                            size="12"
                            :color="checkNumber ? 'success' : 'error'"
                          >
                            {{ checkNumber ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          <span>{{ $t("checknumber") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkSpecialCharacter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkSpecialCharacter ? 'success' : 'error'"
                          >
                            {{
                              checkSpecialCharacter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checkspecialcharacter") }}</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label" for="confirmpassword-field-popupedit-userchatmanagement">{{ $t("confirmNewPassword") }} <span style="color: #CC1F47">*</span></label>
                    <v-text-field
                      id="confirmpassword-field-popupedit-userchatmanagement"
                      ref="confirmpasswordChange"
                      :placeholder="$t('confirmPwd')"
                      :rules="[rules.required]"
                      v-model="edit.confirmpassword"
                      :type="show4 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show4 = !show4"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show4 ?  "mdi-lock-open" : "mdi-lock-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator with Animation -->
                    <transition name="slide-fade" mode="out-in">
                      <div
                        class="password-match"
                        v-if="edit.confirmpassword"
                        key="match"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkPasswordMatch }"
                        >
                          <v-icon
                            size="12"
                            :color="checkPasswordMatch ? 'success' : 'error'"
                          >
                            {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          <span>{{ $t("checkPwdMatch") }}</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
              </v-row>

              <!-- Password Strength Indicator with Animation -->
              <transition name="expand-fade" mode="out-in">
                <v-row class="form-row" v-if="edit.password" key="strength">
                  <v-col cols="12">
                    <div class="password-strength-wrapper">
                      <div class="strength-label">
                        <v-icon
                          :color="passwordStrength.color"
                          :icon="passwordStrength.icon"
                          size="16"
                          class="mr-2"
                        >
                        </v-icon>
                        Password Strength:
                        <span
                          :style="{ color: passwordStrength.color }"
                          class="strength-text"
                        >
                          {{ passwordStrength.text }}
                        </span>
                      </div>
                      <v-progress-linear
                        :model-value="passwordStrength.value"
                        :color="passwordStrength.color"
                        height="6"
                        rounded
                        class="strength-bar"
                      >
                      </v-progress-linear>
                    </div>
                  </v-col>
                </v-row>
              </transition>
            </v-container>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="change-password-actions">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="grey"
            @click="closeChangePassword"
            class="dialog-action-btn cancel-btn"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            id="button-savechangepassword-popupedit-userchatmanagement"
            
            @click="saveChangePassword"
            :disabled="!passwordIsValid"
            class="dialog-action-btn save-btn-edit"
          >
            <img src="@/assets/Icons/new_save_floppy.svg" class="mr-2" alt="Save">
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="570">
      <v-card class="dialog-card">
        <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #FFF5F2 0%, #FFFFFF 100%);">
          <span class="font-weight-bold" style="color: #C30000 !important;">{{ $t("deleteConfirm") }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 600">
          {{ $t("deleteConfirmDescription") }}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
          <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">{{ $t("cancel") }}</button>
          <v-btn class="delete-confirm-btn" :loading="deleting" @click="DeleteUser(item.userId)">
            <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
            <p style="color: #ffffff; font-weight: 500;">{{ $t("delete") }}</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- warning dialog -->
    <v-dialog v-model="showWarningDialog" max-width="570">
      <v-card class="dialog-card">
        <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #FFF8ED 0%, #FFF0DA 100%);">
          <span class="font-weight-bold" style="color: #FFA726 !important;">{{warningTitle}}</span>
          <v-icon
            v-show="showButton"
            size="30"
            class="cursor-pointer float-end"
            @click="closeWarningDialog"
            style="color: black;"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 500">
          <div v-html="warningMessage"></div>
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions v-show="showButton" class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
          <button type="button" class="warning-btn" @click="closeWarningDialog" :disabled="deleting">OK</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import store from "../store";
import ExcelJS from "exceljs";
import { decryptData, decryptShiftData } from "@/utils/decrypt";
import { findTypeName } from "@/utils/fileTypes";
import passwordValidationMixin from "@/mixins/passwordValidationMixin";
import importUserMixin from "@/mixins/importUserMixin";
import warningDialogMixin from "@/mixins/warningDialogMixin";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import DragDropFile from "@/components/DragDropFile.vue";
import LineIcon from "@/components/icons/LineIcon.vue";
export default {
  name: "UserChatManagement",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile, LineIcon },
  mixins: [LogTrace, passwordValidationMixin, importUserMixin, warningDialogMixin],
  directives: {
    mask,
  },
  data() {
    return {
      showSuccess: false,
      SuccessMessage: "",
      // delete/warning dialog state comes from warningDialogMixin
      mask: "##########",
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      formHasErrors: false,
      flagShowSync: false,
      permission: {
        add: true,
        edit: true,
        delete: true,
      },
      mailcheck: false,
      phonecheck: false,
      filters: {
        username: [],
        email: [],
        employeeName: [],
        userType: [],
      },
      DDRole: [
        {
          name: "Admin",
          value: 1,
        },
        {
          name: "ผู้ใช้งานทั่วไป",
          value: 2,
        },
      ],
      numberRules: [(v) => !!v || "Input is required!"],
      rules: {
        required: (value) => value === null || !!value || "Required.",
        min: (v) => v.length >= 10 || "Min 10 numbers",
      },
      Email: null,
      gg: null,
      UserType: null,
      dialog: false,
      edit: {
        id: null,
        username: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        password: null,
        confirmpassword: null,
        roleId: null,
        userType: null,
        groupModel: null,
        model: [],
        modelQuickGroupID: null,
        socialUserID: null,
        recipientId: null,
        recipientId_Instagram: null,
        isUserFromLine: null,
        lockStatus: false,
        userTokenLimit: null,
        userUnlimitedToken: true,
        userImageLimit: null,
        userUnlimitedImage: true,
        userResetDays: null,
        userTokenUsage: null,
        userImageUsage: null,
      },
      user: {
        id: null,
        username: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        password: null,
        confirmpassword: null,
        roleId: null,
        userType: null,
        groupModel: null,
        model: [],
        modelQuickGroupID: null,
        socialUserID: null,
        recipientId: null,
        recipientId_Instagram: null,
        lockStatus: false,
        userTokenLimit: null,
        userUnlimitedToken: true,
        userImageLimit: null,
        userUnlimitedImage: true,
        userResetDays: null,
      },
      // searchGroupModel: null,
      // searchModel: null,
      listDDGroupModel: [],
      listDDModel: [],

      oldPassword: "",
      Editdialog: false,
      Adddialog: false,
      isSearch: false,
      username: "",
      email: "",
      totalTable: 0,
      itemsPerPage: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      today: null,
      userListDDL: [],
      userList: [],
      secretKey: "01234567890123456789012345678901",
      isFirst: true,
      hasSearched: false,
      searchTotalTable: 0,
      sortBy: [],
      sortDesc: [],
      DDQuickModel: [],
      accept:
        "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      fileImportUser: null,
      flagTemplate: false,
      dataTemplate: [
        {
          CSV: "CSV",
          Excel: "Excel",
        },
      ],
      //tempUserWarning: {},

      checkLengthPassword: true,
      checkLowercaseLetter: true,
      checkUppercaseLetter: true,
      checkNumber: true,
      checkSpecialCharacter: true,
      checkPasswordMatch: true,
      statusFormatPassword: false,
      statusPassword: false,
      flagChangePassword: false,
      changPasswordDialog: false,
      resettingUserQuotaIds: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.GetInformation();
      },
      deep: true,
      immediate: true,
    },
    // searchGroupModel(val) {
    //   this.GetGroupModel(val);
    // },
    // searchModel(val) {
    //   this.GetModel(val);
    // },
    "user.password"() {
      this.evaluatePasswordChecks(this.user.password, this.user.confirmpassword);
    },
    "user.confirmpassword"() {
      this.evaluateConfirmPasswordChecks(
        this.user.password,
        this.user.confirmpassword
      );
    },
    "edit.password"() {
      this.evaluatePasswordChecks(this.edit.password, this.edit.confirmpassword);
    },
    "edit.confirmpassword"() {
      this.evaluateConfirmPasswordChecks(
        this.edit.password,
        this.edit.confirmpassword
      );
    },
  },
  mounted() {
    this.GetDate();
    this.GetGroupModel();
    this.GetModel();
    this.GetDDModelQuickGroup();
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
        },
        {
          title: this.$t("username"),
          align: "start",
          sortable: true,
          value: "username",
        },
        {
          title: this.$t("email"),
          align: "start",
          sortable: true,
          value: "email",
        },
        {
          title: this.$t("phonenumber"),
          align: "start",
          sortable: true,
          value: "mobile",
        },
        { title: this.$t("name"), align: "start", sortable: true, value: "fullName" },
        {
          title: this.$t("manage"),
          align: "center",
          sortable: false,
          width: "150px",
        },
      ];
    },
    userResetDaysOptions() {
      return [
        { value: null, text: this.$t("_NoReset") },
        { value: 7, text: this.$t("_Every7Days") },
        { value: 15, text: this.$t("_Every15Days") },
        { value: 30, text: this.$t("_Every30Days") },
      ];
    },
    totalPages() {
      return Math.ceil(this.searchTotalTable / this.options.itemsPerPage);
    },
    itemsPerPageOptions() {
      return [
        { title: '10', value: 10 },
        { title: '20', value: 20 },
        { title: '50', value: 50 },
        { title: '100', value: 100 },
        { title: 'All', value: this.searchTotalTable }, // 🚀 Last item
      ];
    },
    passwordStrength() {
      if (!this.edit.password)
        return {
          value: 0,
          color: "grey",
          text: this.$t("_noPassword"),
          icon: "mdi-minus",
        };

      const score = this.computePasswordScore(this.edit.password);
      return this.passwordStrengthLevel(score);
    },

    passwordIsValid() {
      return (
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter &&
        this.checkPasswordMatch &&
        this.edit.password &&
        this.edit.confirmpassword
      );
    },
    enhancedHeadersTemplate() {
      return [
        {
          title: "CSV",
          key: "csv",
          align: "center",
          width: "50%",
          sortable: false,
        },
        {
          title: "Excel",
          key: "excel",
          align: "center",
          width: "50%",
          sortable: false,
        },
      ];
    },
    noDataMessage() {
      const hasResults = this.filteredUsers.length > 0;
      if (hasResults) {
        return "";
      }

      const usernameQuery = (this.username || "").trim();
      const emailQuery = (this.email || "").trim();

      if (!this.hasSearched || (!usernameQuery && !emailQuery)) {
        return "No data available";
      }

      if (usernameQuery && emailQuery) {
        return `"Username And Email Was Not Found"`;
      }

      if (usernameQuery) {
        return `"Username Was Not Found"`;
      }

      if (emailQuery) {
        return `"Email Was Not Found"`;
      }

      return "No data available";
    },
    filteredUsers() {
      return this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    form() {
      return {
        username: this.user.username,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        email: this.user.email,
        phone: this.user.phone,
        password: this.user.password,
        confirmpassword: this.user.confirmpassword,
        groupModel: this.user.groupModel,
        model: this.user.model,
        modelQuickGroupID: this.user.modelQuickGroupID,
        socialUserID: this.user.socialUserID,
        recipientId: this.user.recipientId,
        recipientId_Instagram: this.user.recipientId_Instagram,
      };
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
    emailRules() {
      if (this.edit.isUserFromLine) {
        return [];
      } else {
        return [this.rules.required, this.validateEmail(this.edit.email)];
      }
    },
    allModelsSelectedEdit() {
      return this.listDDModel.length > 0 && this.edit.model?.length === this.listDDModel.length;
    },
    someModelsSelectedEdit() {
      const selectedCount = this.edit.model?.length ?? 0;
      return selectedCount > 0 && selectedCount < this.listDDModel.length;
    },
    allModelsSelectedAdd() {
      return this.listDDModel.length > 0 && this.user.model?.length === this.listDDModel.length;
    },
    someModelsSelectedAdd() {
      const selectedCount = this.user.model?.length ?? 0;
      return selectedCount > 0 && selectedCount < this.listDDModel.length;
    },
  },

  methods: {
    computePasswordScore(password) {
      let score = 0;

      // Length check
      if (password.length >= 8) score += 20;

      // Character variety checks
      if (/[a-z]/.test(password)) score += 15;

      if (/[A-Z]/.test(password)) score += 15;

      if (/\d/.test(password)) score += 15;

      if (/[^a-zA-Z0-9ก-๙]/.test(password)) score += 15;

      // Additional complexity
      if (password.length >= 12) score += 10;
      if (password.length >= 16) score += 10;

      return score;
    },
    passwordStrengthLevel(score) {
      if (score <= 30) {
        return {
          value: score,
          color: "error",
          text: this.$t("_pwWeak"),
          icon: "mdi-shield-alert",
        };
      } else if (score <= 60) {
        return {
          value: score,
          color: "warning",
          text: this.$t("_pwFair"),
          icon: "mdi-shield-half-full",
        };
      } else if (score <= 80) {
        return {
          value: score,
          color: "info",
          text: this.$t("_pwGood"),
          icon: "mdi-shield-check",
        };
      } else {
        return {
          value: score,
          color: "success",
          text: this.$t("_pwStrong"),
          icon: "mdi-shield-check-outline",
        };
      }
    },
    toggleAllModelsEdit() {
      if (this.allModelsSelectedEdit) {
        this.edit.model = [];
      } else {
        this.edit.model = this.listDDModel.map(model => model.modelDisplayID);
      }
    },
    toggleModelEdit(modelDisplayID) {
      const index = this.edit.model.indexOf(modelDisplayID);
      if (index > -1) {
        this.edit.model.splice(index, 1);
      } else {
        this.edit.model.push(modelDisplayID);
      }
    },
    deselectAllModelsEdit() {
      this.edit.model = [];
    },
    toggleAllModelsAdd() {
      if (this.allModelsSelectedAdd) {
        this.user.model = [];
      } else {
        this.user.model = this.listDDModel.map(model => model.modelDisplayID);
      }
    },
    toggleModelAdd(modelDisplayID) {
      const index = this.user.model.indexOf(modelDisplayID);
      if (index > -1) {
        this.user.model.splice(index, 1);
      } else {
        this.user.model.push(modelDisplayID);
      }
    },
    deselectAllModelsAdd() {
      this.user.model = [];
    },
    // openDeleteDialog / closeDeleteDialog / openWarningDialog /
    // closeWarningDialog come from warningDialogMixin
    getChatUserId(user) {
      const rawUserId = user?.id ?? user?.userId ?? null;
      if (rawUserId == null) {
        return null;
      }

      if (typeof rawUserId === 'string') {
        const trimmedUserId = rawUserId.trim();
        return trimmedUserId.length > 0 ? trimmedUserId : null;
      }

      const userId = Number(rawUserId);
      return Number.isInteger(userId) && userId > 0 ? String(userId) : null;
    },
    findChatUserById(userOrUserId) {
      const userId = typeof userOrUserId === 'string' || typeof userOrUserId === 'number'
        ? String(userOrUserId)
        : this.getChatUserId(userOrUserId);

      if (userId == null) {
        return null;
      }

      return this.userList.find((entry) => this.getChatUserId(entry) === userId) ?? null;
    },
    applyUserQuotaDetail(user, quotaDetail) {
      if (!user || !quotaDetail) {
        return;
      }

      user.userTokenLimit = quotaDetail.userTokenLimit ?? null;
      user.userUnlimitedToken = quotaDetail.userUnlimitedToken !== undefined ? quotaDetail.userUnlimitedToken : true; // NOSONAR
      user.userImageLimit = quotaDetail.userImageLimit ?? null;
      user.userUnlimitedImage = quotaDetail.userUnlimitedImage !== undefined ? quotaDetail.userUnlimitedImage : true; // NOSONAR
      user.userResetDays = quotaDetail.userResetDays ?? null;
      user.userTokenUsage = quotaDetail.userTokenUsage ?? null;
      user.userImageUsage = quotaDetail.userImageUsage ?? null;
    },
    syncUserQuotaDetail(userOrUserId, quotaDetail) {
      if (!quotaDetail) {
        return;
      }

      const userId = typeof userOrUserId === 'string' || typeof userOrUserId === 'number'
        ? String(userOrUserId)
        : this.getChatUserId(userOrUserId);

      if (userId == null) {
        return;
      }

      if (typeof userOrUserId === 'object' && userOrUserId != null) {
        this.applyUserQuotaDetail(userOrUserId, quotaDetail);
      }

      const tableUser = this.findChatUserById(userId);
      if (tableUser != null && tableUser !== userOrUserId) {
        this.applyUserQuotaDetail(tableUser, quotaDetail);
      }

      if (this.getChatUserId(this.edit) === userId && this.edit !== userOrUserId && this.edit !== tableUser) {
        this.applyUserQuotaDetail(this.edit, quotaDetail);
      }
    },
    syncUserQuotaReset(userOrUserId, resetType) {
      const userId = typeof userOrUserId === 'string' || typeof userOrUserId === 'number'
        ? String(userOrUserId)
        : this.getChatUserId(userOrUserId);

      if (userId == null) {
        return;
      }

      if (typeof userOrUserId === 'object' && userOrUserId != null) {
        this.applyUserQuotaReset(userOrUserId, resetType);
      }

      const tableUser = this.findChatUserById(userId);
      if (tableUser != null && tableUser !== userOrUserId) {
        this.applyUserQuotaReset(tableUser, resetType);
      }

      if (this.getChatUserId(this.edit) === userId && this.edit !== userOrUserId && this.edit !== tableUser) {
        this.applyUserQuotaReset(this.edit, resetType);
      }
    },
    refreshUserQuotaDetail(userOrUserId) {
      const userId = typeof userOrUserId === 'string' || typeof userOrUserId === 'number'
        ? String(userOrUserId)
        : this.getChatUserId(userOrUserId);
      if (userId == null) {
        return;
      }

      this.$call.GetUserChatQuotaDetail(
        userId,
        (dataResponse) => {
          if (dataResponse.status != 0) {
            return;
          }

          const quotaDetail = dataResponse.data ?? null;
          if (quotaDetail == null) {
            return;
          }

          this.syncUserQuotaDetail(userOrUserId, quotaDetail);
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    getUserQuotaResetKey(userOrUserId, resetType = 'both') {
      const userId = typeof userOrUserId === 'string' || typeof userOrUserId === 'number' ? userOrUserId : this.getChatUserId(userOrUserId);
      if (userId == null) {
        return null;
      }
      return `${String(userId)}:${resetType}`;
    },
    clearUserQuotaResetting(userOrUserId, resetType = 'both') {
      const key = this.getUserQuotaResetKey(userOrUserId, resetType);
      if (key == null) {
        return;
      }
      this.resettingUserQuotaIds = this.resettingUserQuotaIds.filter((id) => id !== key);
    },
    isUserQuotaResetting(user, resetType = 'both') {
      const key = this.getUserQuotaResetKey(user, resetType);
      return key != null && this.resettingUserQuotaIds.includes(key);
    },
    applyUserQuotaReset(user, resetType) {
      if (resetType === 'token') {
        user.userTokenUsage = 0;
        return;
      }

      if (resetType === 'image') {
        user.userImageUsage = 0;
        return;
      }

      user.userTokenUsage = 0;
      user.userImageUsage = 0;
    },
    resetUserQuota(user, resetType) {
      const userId = this.getChatUserId(user);
      const resetKey = this.getUserQuotaResetKey(userId, resetType);
      const quotaLabel = resetType === 'image' ? this.$t('_imageCreditLabel') : this.$t('_tokenQuotaLabel');
      if (userId == null) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('warning'),
          text: this.$t('_chatUserIdInvalid'),
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }

      if (this.isUserQuotaResetting(user, resetType) || resetKey == null) {
        return;
      }

      this.$swal.fire({
        icon: 'warning',
        title: this.$t('_resetChatUserQuotaTitle', { label: quotaLabel }),
        text: this.$t('_resetQuotaConfirmText', { label: quotaLabel }),
        showCancelButton: true,
        confirmButtonText: this.$t('_Reset'),
        cancelButtonText: this.$t('cancel'),
        confirmButtonColor: '#c32e0e',
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        this.resettingUserQuotaIds.push(resetKey);
        const timeoutHandle = globalThis.setTimeout(() => {
          this.clearUserQuotaResetting(userId, resetType);
          this.$swal.fire({
            icon: 'error',
            title: this.$t('warning'),
            text: this.$t('_resetQuotaTimeout', { label: quotaLabel }),
            showConfirmButton: false,
            timer: 2500,
          });
        }, 15000);

        this.$call.ResetUserChatQuota(
          userId,
          resetType,
          (dataResponse) => {
            globalThis.clearTimeout(timeoutHandle);
            this.clearUserQuotaResetting(userId, resetType);

            if (dataResponse.status == 0) {
              this.syncUserQuotaReset(userId, resetType);
              this.$swal.fire({
                title: `✔ ${quotaLabel.charAt(0).toUpperCase() + quotaLabel.slice(1)}` + this.$t('_resetSuffix'),
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title',
                },
              });
              return;
            }

            this.$swal.fire({
              icon: 'error',
              title: this.$t('warning'),
              text: dataResponse.message || this.$t('_unableToResetQuota', { label: quotaLabel }),
              showConfirmButton: false,
              timer: 2000,
            });
          },
          (errorResource) => {
            globalThis.clearTimeout(timeoutHandle);
            this.clearUserQuotaResetting(userId, resetType);
            console.error(errorResource);
            this.$swal.fire({
              icon: 'error',
              title: this.$t('warning'),
              text: this.$t('_unableToResetQuota', { label: quotaLabel }),
              showConfirmButton: false,
              timer: 2000,
            });
          }
        );
      });
    },
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:

      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (
        this.$refs.fileUploader &&
        typeof this.$refs.fileUploader.openFileDialog === "function"
      ) {
        this.$refs.fileUploader.openFileDialog();
      }
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput =
          this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    async SyncUser() {
      this.dialog = true;
      await this.$call.SyncUserChat(
        null,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.SuccessMessage =  dataResponse.data.message ?? "Sync completed successfully.";
            this.showSuccess = true;
            clearTimeout(this._addToastTimer);
            this._addToastTimer = setTimeout(() => {
              this.showSuccess = false;
            }, 1500);
          } else {
            this.openWarningDialog(
              "Warning!",
              this.$t("_SSOWarning"),
            );
          }
          this.dialog = false;
          this.GetInformationDefault();
        },
        (errorResource) => {
          console.error(errorResource);
          this.dialog = false;
        }
      );
    },
    processUpload(e) {
      if (e.length > 0) {
        this.fileImportUser = e[0];
        const fileType = this.fileImportUser.name
          .split(".")
          .pop()
          .toLowerCase();

        if (fileType === "xlsx" || fileType === "xls") {
          // Handle Excel files
          const reader = new FileReader();
          reader.onload = async (event) => {
            try {
              const workbook = new ExcelJS.Workbook();
              await workbook.xlsx.load(event.target.result);

              // ใช้ worksheet แรก
              const worksheet = workbook.worksheets[0];
              const jsonData = [];

              // อ่านข้อมูลจาก headers
              const headers = [];
              worksheet.getRow(1).eachCell((cell, colNumber) => {
                headers[colNumber - 1] = cell.value;
              });

              // แปลงข้อมูลเป็น JSON
              worksheet.eachRow((row, rowNumber) => {
                if (rowNumber !== 1) {
                  // ข้ามแถวแรกที่เป็นหัวข้อ
                  const rowData = {};
                  row.eachCell((cell, colNumber) => {
                    rowData[headers[colNumber - 1]] = cell.value;
                  });
                  jsonData.push(rowData);
                }
              });
              this.validateData(jsonData);
            } catch (error) {
              console.error("Error processing Excel file:", error);
              this.$swal.fire({
                icon: "error",
                title: this.$t("error"),
                text: this.$t("_failedProcessExcel") + "\n" + error.message,
              });
            }
          };
          reader.readAsArrayBuffer(this.fileImportUser); // NOSONAR
        } else if (fileType === "csv") {
          const reader = this.createCsvImportReader();
          reader.readAsText(this.fileImportUser); // NOSONAR
        } else {
          this.openWarningDialog(
          "Invalid file type",
          `Please upload an Excel (.xlsx) or CSV (.csv) file.`
        );
        }
      }
    },
    validateData(data) {
      const requiredColumns = ["User Name", "Email"];
      const missingColumns = requiredColumns.filter(
        (col) => !Object.keys(data[0] || {}).includes(col)
      );
      if (missingColumns.length > 0) {
        this.openWarningDialog(
          "Missing Columns",
          `The following required columns are missing: ${missingColumns.join(", ")}`
        );
        return;
      }
      const usernames = data
        .map((row) => (typeof row["User Name"] === "string" ? row["User Name"] : String(row["User Name"] ?? "")).trim())
        .filter(Boolean);
      const emails = data
        .map((row) => (typeof row["Email"] === "string" ? row["Email"] : String(row["Email"] ?? "")).trim())
        .filter(Boolean);

      const duplicateUsernames = usernames.filter(
        (value, index, self) => self.indexOf(value) !== index
      );
      const duplicateEmails = emails.filter(
        (value, index, self) => self.indexOf(value) !== index
      );

      if (duplicateUsernames.length > 0 || duplicateEmails.length > 0) {
        let errorMessage = "";
        if (duplicateUsernames.length > 0) {
          errorMessage += `Duplicate usernames</br> - ${[
            ...new Set(duplicateUsernames),
          ].join(", ")}</br>`;
        }
        if (duplicateEmails.length > 0) {
          errorMessage += `Duplicate emails</br> - ${[
            ...new Set(duplicateEmails),
          ].join(", ")}</br>`;
        }
        this.openWarningDialog(
          this.$t("warning"),
          errorMessage
        );
      } else {
        this.ConfirmProcess();
      }
    },

    hasImportWarnings(data) {
      return (
        data.mesDupUser.length > 0 ||
        data.mesDupEmail.length > 0 ||
        data.mesEmailNotFormat.length > 0 ||
        data.mesFillAll.length > 0 ||
        data.mesModelNotFormat.length > 0 ||
        data.mesDupSocialUserID.length > 0 ||
        data.mesDupRecipientID.length > 0
      );
    },
    buildImportInlineSection(items, label) {
      let htmlString = "";
      const count = items.length;
      for (let i = 0; i < count; i++) {
        if (i == 0) {
          htmlString += label;
        }
        htmlString += items[i];
        htmlString += i == count - 1 ? "</br>" : ", ";
      }
      return htmlString;
    },
    buildImportFillAllSection(items) {
      let htmlString = "";
      const count = items.length;
      for (let i = 0; i < count; i++) {
        if (i == 0) {
          htmlString += "Please fill the required fields</br>";
        }
        htmlString += " -" + items[i] + "</br>";
      }
      return htmlString;
    },
    buildImportWarningHtml(data) {
      let htmlString = "";
      htmlString += this.buildImportInlineSection(data.mesDupUser, "Duplicate username - ");
      htmlString += this.buildImportInlineSection(data.mesDupEmail, "Duplicate email - ");
      htmlString += this.buildImportInlineSection(
        data.mesEmailNotFormat,
        "Email is not formatted correctly - "
      );
      htmlString += this.buildImportFillAllSection(data.mesFillAll);
      htmlString += this.buildImportInlineSection(
        data.mesModelNotFormat,
        "Model is not formatted correctly - "
      );
      htmlString += this.buildImportInlineSection(
        data.mesDupSocialUserID,
        "Duplicate Social UserID - "
      );
      htmlString += this.buildImportInlineSection(
        data.mesDupRecipientID,
        "Duplicate Recipient ID - "
      );
      return htmlString;
    },
    handleImportSuccess(dataResponse) {
      if (this.hasImportWarnings(dataResponse.data)) {
        const htmlString = this.buildImportWarningHtml(dataResponse.data);


        this.openWarningDialog(
          "Warning!",
          htmlString
        );
      } else {
        this.SuccessMessage = dataResponse.message;
          this.showSuccess = true;
          clearTimeout(this._addToastTimer);
          this._addToastTimer = setTimeout(() => {
            this.showSuccess = false;
          }, 1500);
        this.GetInformation();
      }
    },
    async ImportUser() {
      this.dialog = true;
      const formDataDoc = new FormData();
      formDataDoc.append("entity", this.fileImportUser);

      const requestUser = {
        entity: formDataDoc,
        isUserChat: true,
      };

      await this.$call.ImportUser(
        requestUser,
        null,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.handleImportSuccess(dataResponse);
          } else {
            this.openWarningDialog(
              "Warning!",
              dataResponse.message
            );
          }
          this.options.page = 1;
          this.GetInformationDefault();
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },

    // async CreateCSVUserWarning(DupUser, DupEmail, EmailNotFormat, FillAll, countMax) {
    //   let self = this;
    //   let array = [['\ufeffDuplicate username', '\ufeffDuplicate email', '\ufeffEmail is not formatted correctly', '\ufeffPlease fill the required fields']];
    //   for (let i = 0; i < countMax; i++) {
    //     array.push([DupUser[i], DupEmail[i], EmailNotFormat[i], FillAll[i]]);
    //   }
    //   await self.CreateCSVFileDownload(array);
    // },

    // async CreateCSVFileDownload(array) {
    //   let str = '';
    //   for (const item of array) {
    //     let line = '';
    //     line = item.join(',');
    //     str += line + '\r\n';
    //   }
    //   let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
    //   let link = document.createElement('a');
    //   let url = URL.createObjectURL(blob);
    //   link.setAttribute('href', url);
    //   link.setAttribute('download', `UserWarning.csv`);
    //   link.style.visibility = 'hidden';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },

    linkDownload(modelType) {
      if (modelType === "Excel") {
        // สร้าง Excel ด้วย ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Template");

        // กำหนดคอลัมน์
        worksheet.columns = [
          { header: "User Name", key: "username", width: 20 },
          { header: "Password", key: "password", width: 20 },
          { header: "First Name", key: "firstName", width: 20 },
          { header: "Last Name", key: "lastName", width: 20 },
          { header: "Email", key: "email", width: 25 },
          { header: "Phone Number", key: "phoneNumber", width: 15 },
          { header: "Social User ID", key: "socialUserID", width: 25 },
          { header: "Recipient ID (Facebook)", key: "recipientId", width: 25 },
          {
            header: "Recipient ID (Instagram)",
            key: "recipientId_Instagram",
            width: 25,
          },
          { header: "Model", key: "model", width: 20 },
        ];

        // ปรับแต่งสไตล์หัวคอลัมน์
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE0E0E0" },
        };

        // ขนาดคอลัมน์อัตโนมัติ
        worksheet.columns.forEach((column) => {
          column.width = column.width || 15;
        });

        // ดาวน์โหลดไฟล์
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Template_UserChat_${modelType}.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        });

        this.flagTemplate = false;
      } else if (modelType === "CSV") {
        // สำหรับ CSV ยังใช้วิธีเดิม
        let req = {
          modelType: modelType,
          filename: "UserChat",
        };
        this.$call.DownloadTemplateUser(
          req,
          (dataResponse) => {
            if (dataResponse) {
              let fileURL = globalThis.URL.createObjectURL(
                new Blob([dataResponse])
              );
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;

              let fileNameshow = `Template_UserChat_${modelType}${this.findTypeName(
                modelType
              )}`;
              fileLink.setAttribute("download", fileNameshow);
              document.body.appendChild(fileLink);

              fileLink.click();
            }
            this.flagTemplate = false;
          },
          (errorResource) => {
            this.flagTemplate = false;
            console.error(errorResource);
          }
        );
      }
    },

    findTypeName(modelType) {
      return findTypeName(modelType);
    },

    // GetModel(val) {
    //   console.log("GetModel", val);
    //   let self = this;
    //   let temp = {
    //     page: 1,
    //     perPage: 5,
    //     modelName: val,
    //   };
    //   self.$call.GetTableGPTModel(
    //     temp,
    //     (dataResponse) => {
    //       if (dataResponse.status == 0) {
    //         self.listDDModel = dataResponse.data.data;
    //       } else {
    //         self.listDDModel = [];
    //       }
    //     },
    //     (errorResource) => {
    //       console.error(errorResource);
    //     }
    //   );
    // },
    // GetGroupModel(val) {
    //   let self = this;
    //   let temp = {
    //     page: 1,
    //     perPage: 5,
    //     name: val,
    //   };
    //   self.$call.GetTableGroupModel(
    //     temp,
    //     (dataResponse) => {
    //       if (dataResponse.status == 0) {
    //         self.listDDGroupModel = dataResponse.data.data;
    //       } else {
    //         self.listDDGroupModel = [];
    //       }
    //     },
    //     (errorResource) => {
    //       console.error(errorResource);
    //     }
    //   );
    // },
    GetModel() {
      this.$call.DDGPTModel_IsPublishByUser(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModel = dataResponse.data;
          } else {
            this.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetGroupModel() {
      this.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDGroupModel = dataResponse.data;
          } else {
            this.listDDGroupModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //NOSONAR

      return re.test(email) || "invalid email";
    },
    Search() {
      this.isSearch = true;
      this.hasSearched = !!(
        (this.username && this.username.trim()) ||
        (this.email && this.email.trim())
      );
      this.options.page = 1;
      this.GetInformationDefault();
    },
    GetInformation() {
      try {
        this.loadingTable = true;

        let { page, itemsPerPage, sortBy } = this.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }

        let temp = {
          page: this.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : this.totalTable, // NOSONAR
          username: this.username,
          eMail: this.email,
          isUserChat: true,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        this.$call.GetTableUserChatManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.flagShowSync = dataResponse.data.flag;
              this.searchTotalTable = dataResponse.data.total;
              this.userList = dataResponse.data.data;
              this.userListDDL = dataResponse.data.data;
              this.totalTable = this.isFirst
                ? dataResponse.data.total
                : this.totalTable;
            } else {
              this.flagShowSync = false;
              this.userList = [];
              this.totalTable = 0;
              this.searchTotalTable = 0;
            }
            this.loadingTable = false;
            this.isSearch = false;
            this.isFirst = false;
          },
          (errorResource) => {
            this.loadingTable = false;
            this.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetInformationDefault() {
      try {
        this.dialog = true;
        const { page, itemsPerPage } = this.options;
        let temp = {
          page: this.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : this.totalTable, // NOSONAR
          username: this.username,
          eMail: this.email,
          isUserChat: true,
          sortDesc: null,
          sortBy: null,
        };
        this.$call.GetTableUserChatManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.searchTotalTable = dataResponse.data.total;
              this.userList = dataResponse.data.data;
              this.userListDDL = dataResponse.data.data;
              this.totalTable = this.isFirst
                ? dataResponse.data.total
                : this.totalTable;
            } else {
              this.userList = [];
              this.totalTable = 0;
              this.searchTotalTable = 0;
            }
            this.dialog = false;
            this.isSearch = false;
            this.isFirst = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    EditUser(temp) {
      this.Editdialog = true;
      this.edit.id = temp.userId;
      this.edit.username = temp.username;
      this.edit.firstname = temp.firstName;
      this.edit.lastname = temp.lastName;
      this.edit.roleId =
        temp.roleId == null || temp.roleId == undefined ? 2 : temp.roleId;
      this.edit.userType = temp.userType;
      this.edit.email = temp.email;
      this.edit.phone = temp.mobile;
      this.edit.modelQuickGroupID = temp.modelQuickGroupID;
      this.edit.socialUserID = temp.socialUserID;
      this.edit.recipientId = temp.recipientId;
      this.edit.recipientId_Instagram = temp.recipientId_Instagram;
      this.edit.isUserFromLine = temp.isUserFromLine;
      this.edit.lockStatus = temp.isLock;
      this.edit.userTokenLimit = temp.userTokenLimit ?? null;
      this.edit.userUnlimitedToken = temp.userUnlimitedToken !== undefined ? temp.userUnlimitedToken : true; // NOSONAR
      this.edit.userImageLimit = temp.userImageLimit ?? null;
      this.edit.userUnlimitedImage = temp.userUnlimitedImage !== undefined ? temp.userUnlimitedImage : true; // NOSONAR
      this.edit.userResetDays = temp.userResetDays ?? null;
      this.edit.userTokenUsage = temp.userTokenUsage ?? null;
      this.edit.userImageUsage = temp.userImageUsage ?? null;
      this.edit.confirmpassword = null;
      this.edit.password = null;
      this.flagChangePassword = false;
      this.checkLengthPassword = true;
      this.checkLowercaseLetter = true;
      this.checkUppercaseLetter = true;
      this.checkNumber = true;
      this.checkSpecialCharacter = true;
      this.checkPasswordMatch = true;
      if (temp.groupModel == null) {
        this.edit.groupModel = null;
      } else {
        this.edit.groupModel = Number.parseInt(temp.groupModel);
      }
      // copy the array so toggling models here never mutates the table row data
      this.edit.model = Array.isArray(temp.model) ? [...temp.model] : [];

      this.refreshUserQuotaDetail(this.edit.id);
    },
    isUpdateUserValid(emailvali) {
      return (
        this.edit.username != null && this.edit.username != "" &&
        this.edit.lastname != null && this.edit.lastname != "" &&
        this.edit.firstname != null && this.edit.firstname != "" &&
        this.edit.email != null && this.edit.email != "" &&
        // this.edit.phone != null &&
        // ((this.edit.password != '' && this.flagChangePassword == false) ||
        //  (this.edit.password != '' && this.edit.confirmpassword != '' && this.flagChangePassword == true &&
        //   this.statusPassword == true && this.statusFormatPassword == true)) &&
        // this.statusPassword == true &&
        // this.statusFormatPassword == true &&
        (!this.flagChangePassword ||
          (this.flagChangePassword &&
            this.edit.password != null && this.edit.password != "" &&
            this.edit.confirmpassword != null && this.edit.confirmpassword != "" &&
            this.statusPassword &&
            this.statusFormatPassword)) &&
        // this.edit.roleId != null &&
        // this.edit.userType != "" &&
        (this.edit.groupModel != null || (this.edit.model != null && this.edit.model.length != 0)) &&
        emailvali /*&&
        phonevali*/
      );
    },
    buildUpdateUserRequest() {
      return {
        userId: this.edit.id,
        username: this.edit.username,
        password: this.flagChangePassword ? this.edit.password : "",
        idcard: 0,
        prefixId: 0,
        firstName: this.edit.firstname,
        lastName: this.edit.lastname,
        // roleId: 1,
        roleId: this.edit.roleId,
        // userType: this.edit.userType,
        mobile: this.edit.phone,
        eMail: this.edit.email,
        groupModel: this.edit.groupModel,
        model: this.edit.model,
        modelQuickGroupID: this.edit.modelQuickGroupID,
        socialUserID: this.edit.socialUserID,
        recipientId: this.edit.recipientId,
        recipientId_Instagram: this.edit.recipientId_Instagram,
        lockStatus: this.edit.lockStatus,
        isUserChat: true,
        userTokenLimit: this.edit.userUnlimitedToken ? null : this.edit.userTokenLimit,
        userUnlimitedToken: this.edit.userUnlimitedToken,
        userImageLimit: this.edit.userUnlimitedImage ? null : this.edit.userImageLimit,
        userUnlimitedImage: this.edit.userUnlimitedImage,
        userResetDays: this.edit.userResetDays,
      };
    },
    applyUpdatedUserCookies() {
      if (Cookies.get("userId") == this.edit.id) {
        Cookies.set(
          "fullName",
          `${this.edit.firstname} ${this.edit.lastname}`
        );
        store.state.fullName = `${this.edit.firstname} ${this.edit.lastname}`;
        Cookies.set("username", this.edit.username);
        if (this.oldPassword != this.edit.password) {
          this.$call.ClearUserInfo();
          this.$router.push("/login");
        }
      }
    },
    resetEditAfterUpdate() {
      this.Editdialog = false;
      this.edit.name = null;
      this.edit.surname = null;
      this.edit.email = null;
      this.edit.department = null;
      this.edit.section = null;
      this.edit.status = null;
      this.edit.roleId = null;
      this.edit.userType = null;
      this.edit.model = [];
      this.edit.groupModel = null;
      this.edit.modelQuickGroupID = null;
      this.edit.socialUserID = null;
      this.edit.recipientId = null;
      this.edit.recipientId_Instagram = null;
      this.edit.lockStatus = false;
      this.edit.userTokenLimit = null;
      this.edit.userUnlimitedToken = true;
      this.edit.userImageLimit = null;
      this.edit.userUnlimitedImage = true;
      this.edit.userResetDays = null;
      this.edit.userTokenUsage = null;
      this.edit.userImageUsage = null;
    },
    showUpdateUserValidationWarning(emailvali) {
      if (
        !this.edit.username || !this.edit.firstname || !this.edit.lastname || !this.edit.email
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          "Please fill all required fields",
          false,
          2000
        );
      } else if (emailvali != true /*|| phonevali != true*/) { // NOSONAR
        this.openWarningDialog(
          "Warning!",
          "Please fill correct email format.",
          false,
          2000
        );
      } else if (
        this.edit.groupModel == null &&
        (this.edit.model == null || this.edit.model.length < 1)
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          "Please select at least one of Model Display or Model Group.",
          false,
          1800
        );
      } else if (
        this.flagChangePassword &&
        (this.edit.password == null || this.edit.password == "" ||
         this.edit.confirmpassword == null || this.edit.confirmpassword == "")
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          "Please fill Password and Confirm Password.",
          false,
          2000
        );
      }
    },
    UpdateUser() {
      try {
        this.dialog = true;
        let emailvali = this.validateEmail(this.edit.email);
        if (this.isUpdateUserValid(emailvali)) {
          let tempUser = this.buildUpdateUserRequest();
          this.$call.UpdateUserChat(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.applyUpdatedUserCookies();
                this.SuccessMessage = dataResponse.message;
                this.showSuccess = true;
                clearTimeout(this._addToastTimer);
                this._addToastTimer = setTimeout(() => {
                  this.showSuccess = false;
                }, 1500);
                this.resetEditAfterUpdate();
                this.GetInformation();
              } else {
                this.openWarningDialog(
                  "Warning!",
                  dataResponse.data.message,
                  false,
                  1800
                );
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          this.showUpdateUserValidationWarning(emailvali);
          this.formHasErrors = true;
          this.Editdialog = true;
          this.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    DeleteUser(id) {
      try {
              this.dialog = true;
              this.deleting = true;
              this.$call.DeleteUserChat(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.showDeleteDialog = false;
                    this.SuccessMessage = "Successfully Deleted !";
                    this.showSuccess = true;
                    clearTimeout(this._addToastTimer);
                    this._addToastTimer = setTimeout(() => {
                      this.showSuccess = false;
                    }, 1500);
                    this.totalTable = this.totalTable - 1;
                    this.GetInformation();
                  }
                  this.dialog = false;
                  this.deleting = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.deleting = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteUser");
      }
    },
    // Single source of truth for clearing the Add dialog, used by both Cancel and
    // a successful save so the next Add always starts from the same clean state.
    resetAddUserForm() {
      this.Adddialog = false;
      this.user.username = null;
      this.user.firstname = null;
      this.user.lastname = null;
      this.user.email = null;
      this.user.phone = null;
      this.user.password = null;
      this.user.confirmpassword = null;
      this.user.model = [];
      this.user.groupModel = null;
      this.user.modelQuickGroupID = null;
      this.user.socialUserID = null;
      this.user.recipientId = null;
      this.user.recipientId_Instagram = null;
      this.user.lockStatus = false;
      this.user.userTokenLimit = null;
      this.user.userUnlimitedToken = true;
      this.user.userImageLimit = null;
      this.user.userUnlimitedImage = true;
      this.user.userResetDays = null;
      this.checkLengthPassword = true;
      this.checkLowercaseLetter = true;
      this.checkUppercaseLetter = true;
      this.checkNumber = true;
      this.checkSpecialCharacter = true;
      this.checkPasswordMatch = true;
      this.show1 = false;
      this.show2 = false;
    },
    closeadd() {
      Object.keys(this.form).forEach((f) => {
        this.$refs[f]?.reset?.();
      });

      this.resetAddUserForm();
    },
    isAddUserValid(emailvali) {
      return (
        this.user.username != null &&
        this.user.lastname != null &&
        this.user.firstname != null &&
        this.user.email != null &&
        // this.user.phone != null &&
        this.user.password != null &&
        this.user.confirmpassword != null &&
        this.statusPassword &&
        this.statusFormatPassword &&
        // this.user.roleId != null &&
        // this.user.userType != null &&
        (this.user.groupModel != null || (this.user.model != null && this.user.model.length != 0)) &&
        emailvali == true /* NOSONAR */ /*&&
        phonevali == true*/
      );
    },
    buildAddUserRequest() {
      return {
        username: this.user.username,
        password: this.user.password,
        idCard: 0,
        prefixId: 0,
        firstName: this.user.firstname,
        lastName: this.user.lastname,
        // roleId: 1,
        roleId: this.user.roleId,
        // userType: this.user.userType,
        mobile: this.user.phone,
        eMail: this.user.email,
        groupModel: this.user.groupModel,
        model: this.user.model,
        modelQuickGroupID: this.user.modelQuickGroupID,
        socialUserID: this.user.socialUserID,
        recipientId: this.user.recipientId,
        recipientId_Instagram: this.user.recipientId_Instagram,
        isUserChat: true,
        lockStatus: this.user.lockStatus,
        userTokenLimit: this.user.userUnlimitedToken ? null : this.user.userTokenLimit,
        userUnlimitedToken: this.user.userUnlimitedToken,
        userImageLimit: this.user.userUnlimitedImage ? null : this.user.userImageLimit,
        userUnlimitedImage: this.user.userUnlimitedImage,
        userResetDays: this.user.userResetDays,
      };
    },
    resetUserAfterAdd() {
      this.resetAddUserForm();
    },
    showAddUserValidationWarning(emailvali) {
      if (
        !this.user.username || !this.user.firstname || !this.user.lastname || !this.user.email
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          "Please fill all required fields",
          false,
          2000
        );
      } else if (emailvali != true /*|| phonevali != true*/) { // NOSONAR
        this.openWarningDialog(
          this.$t("warning"),
          this.$t("Please fill correct format!"),
          false,
          2000
        );
      } else if (
        this.user.groupModel == null &&
        (this.user.model == null || this.user.model.length < 1)
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          "Please select at least one of Model Display or Model Group.",
          false,
          1800
        );
      } else if (
        this.user.password == null &&
        this.user.confirmpassword == null
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          this.$t("Please fill Password and Confirm Password"),
          false,
          2000
        );
      } else if (
        this.user.password == null &&
        this.user.confirmpassword != null
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          this.$t("Please fill Password"),
          false,
          2000
        );
      } else if (
        this.user.password != null &&
        this.user.confirmpassword == null
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          this.$t("Please fill Confirm Password"),
          false,
          2000
        );
      } else if (
        this.user.password != this.user.confirmpassword &&
        !this.checkPasswordMatch
      ) {
        this.openWarningDialog(
          this.$t("warning"),
          this.$t("passwordMismatchFillCorrectly"),
          false,
          2000
        );
      }
    },
    AddUser() {
      try {
        this.dialog = true;
        let emailvali = this.validateEmail(this.user.email);
        if (this.isAddUserValid(emailvali)) {
          let tempUser = this.buildAddUserRequest();

          this.$call.CreateUserChat(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.SuccessMessage = "Chat User Created Successfully.";
                this.showSuccess = true;
                clearTimeout(this._addToastTimer);
                this._addToastTimer = setTimeout(() => {
                  this.showSuccess = false;
                }, 3000);
                this.resetUserAfterAdd();
                this.dialog = false;
                this.totalTable = this.totalTable + 1;
                this.GetInformation();
              } else {
                this.openWarningDialog(
                  "Warning!",
                  dataResponse.data.message,
                  false,
                  1800
                );
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          this.showAddUserValidationWarning(emailvali);
          this.formHasErrors = true;
          this.Adddialog = true;
          this.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "AddUser");
      }
    },
    closeChangePassword() {
      this.edit.password = null;
      this.edit.confirmpassword = null;
      this.resetPasswordCheckFlags();
      this.changPasswordDialog = false;
      this.show3 = false;
      this.show4 = false;
    },
    saveChangePassword() {
      try {
        this.dialog = true;
        if (this.isChangePasswordValid()) {
          let temp = {
            userID: this.edit.id,
            password: this.edit.password,
          };
          this.$call.SaveChangePasswordUserChat(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.SuccessMessage = dataResponse.message;
                this.showSuccess = true;
                clearTimeout(this._addToastTimer);
                this._addToastTimer = setTimeout(() => {
                  this.showSuccess = false;
                }, 1500);
                this.edit.password = null;
                this.edit.confirmpassword = null;
                this.resetPasswordCheckFlags();
                this.changPasswordDialog = false;
                this.show3 = false;
                this.show4 = false;
              } else {
                this.openWarningDialog(
                  "Warning!",
                  dataResponse.data.message,
                  false,
                  2000
                );
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (this.edit.password != null && this.edit.confirmpassword == null) {
            this.openWarningDialog(
              this.$t("warning"),
              this.$t("Please fill Confirm Password"),
              false,
              2000
            );
          } else if (
            this.edit.password == null &&
            this.edit.confirmpassword != null
          ) {
            this.openWarningDialog(
              this.$t("warning"),
              this.$t("Please fill Password"),
              false,
              2000
            );
          } else if (
            this.edit.password == null &&
            this.edit.confirmpassword == null
          ) {
            this.openWarningDialog(
              this.$t("warning"),
              this.$t("Please fill Password and Confirm Password"),
              false,
              2000
            );
          } else if (
            !this.checkLengthPassword ||
            !this.checkLowercaseLetter ||
            !this.checkUppercaseLetter ||
            !this.checkNumber ||
            !this.checkSpecialCharacter
          ) {
            this.openWarningDialog(
              this.$t("warning"),
              this.$t("Please fill correct format!"),
              false,
              2000
            );
          } else if (
            this.edit.password != this.edit.confirmpassword &&
            !this.checkPasswordMatch
          ) {
            this.openWarningDialog(
              this.$t("warning"),
              this.$t("passwordMismatchFillCorrectly"),
              false,
              2000
            );
          } else {
            this.openWarningDialog(
              this.$t("warning"),
              this.$t("Please fill all fields!!!"),
              false,
              2000
            );
          }
          this.formHasErrors = true;
          this.changPasswordDialog = true;
          this.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "saveChangePassword");
      }
    },
    decryptData(encryptedText, key) {
      return decryptData(encryptedText, key);
    },
    decryptShiftData(encryptedText, shift) {
      return decryptShiftData(encryptedText, shift);
    },
    GetDDModelQuickGroup() {
      this.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDQuickModel = dataResponse.data;
          } else {
            this.DDQuickModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
.user-management-wrapper {
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
  padding-right: 32px !important;
}

.card2 {
  border: none !important;
  box-shadow: none !important;
  padding-top: 1rem;
}
.title {
  color: white;
}
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.pass {
  display: none;
}

.failed {
  display: block;
  color: red;
}

.page-title :deep(.v-toolbar-title__placeholder) {
  height: 40px !important;
}

.ChangePassword:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

.action-controls {
  border: none !important;
  background-color: white !important;
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 0px !important;
  gap: 24px;
  transition: all 0.2s ease;
  min-width: 300px;
}

.control-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: none !important;
}
.template-btn,
.import-btn {
  display: flex;
  min-width: 100px;
  margin: 0px !important;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid #C32E0E;
  color: #C32E0E !important;
  white-space: nowrap;
  width: 138px;
  height: 40px;
}
.control-btn:hover {
  background-color: #FDE4DF !important;
  transform: none;
}
.control-btn:active {
  background-color: #FAADA0 !important;
}
.sync-btn{
  display: flex;
  height: 40px;
  padding: 14px 24px;
  margin: 0px !important;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  color: var(--White, #FFF) !important;
  text-align: center;
  font-family: Poppins, sans-serif;
  font-size: 1.1rem !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background: var(--active, #2ABF56) !important;
}
.sync-btn:hover {
  background: linear-gradient(100deg, #2ABF56 0%, #65F28F 100%) !important;
}
.template-btn :deep(.v-btn__content),
.import-btn :deep(.v-btn__content) {
  gap: 8px !important;
}
.create-btn {
  display: flex;
  height: 40px !important;
  padding: 14px 24px;
  margin: 0px !important;
  justify-content: center;
  font-size: 18px !important;
  box-shadow: none !important;
  align-items: center;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%);
  color: white;
  transition: none !important;
}
.create-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
  box-shadow: none !important;
  transition: none !important;
}
.create-btn :deep(.v-btn__content span) {
  font-weight: 500 !important;
  font-size: 1.1rem;
}

.modern-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(211, 47, 47, 0.2);
}

.modern-autocomplete :deep(.v-chip) {
  padding: 2px 10px !important;
  height: auto;
}
.modern-autocomplete :deep(.v-chip__close) {
  border-left: 1px solid #CCCCCC;
  padding-left: 3px;
  margin-right: 3px;
}
.modern-autocomplete :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}
.autocomplete-item:hover {
  background-color: #CDD5F3 !important;
}
/* Template Dialog Styles */
.template-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
}

.template-header {
  color: black !important;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px !important;
  border-bottom: 1px solid rgba(var(--v-border-color), 0.12);
}

.user-quota-indicator-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-quota-card {
  flex: 1 1 auto;
  min-width: 0;
}

.user-quota-progress-row {
  display: block;
}

.user-quota-progress {
  width: 100%;
}

.user-reset-button {
  min-width: 48px !important;
  width: 48px !important;
  height: 48px !important;
  padding: 0 !important;
  border-radius: 14px !important;
  background: linear-gradient(135deg, #c32e0e 0%, #ef5f3c 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 8px 18px rgba(195, 46, 14, 0.24) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
  flex: 0 0 auto;
}

.user-reset-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(195, 46, 14, 0.3) !important;
}

.user-reset-button:disabled {
  box-shadow: none !important;
}

.user-reset-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
.template-header :deep(.close-btn) {
  color: black !important;
}
.template-header :deep(.mdi-close) {
  font-size: 42px;
  font-weight: 400 !important;
}
.template-header :deep(.close-btn):hover {
  color: black !important;
}
.userNameInput :deep(.v-input__control .v-field),
.emailInput :deep(.v-input__control .v-field) {
  border-radius: 16px !important;
  background-color: white !important;
  display: flex;
  padding: 8px 16px;
  align-items: center;
  height: 40px !important;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
}

.userNameInput :deep(.v-field__input) {
  padding: 0 !important;
}

.btn-text {
  font-weight: 500;
  text-transform: none;
}
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #1e863d 0%, #135928 100%) !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 700px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.info-icon:hover {
  color: #9e9e9e !important;
  cursor: unset;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 28px;
  opacity: 0.9;
}

.v-autocomplete :deep(.v-chip) {
  border-radius: 16px;
  border: 1px solid rgba(195, 46, 14, 0.24);
  background: rgba(195, 46, 14, 0.10);
  color: var(--main, #C32E0E);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 4px 8px;
}

.no-data-placeholder {
  padding: 16px 0;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
}

/* Optional: chip close (x) button color */

.label-with-icon {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.info-icon {
  cursor: pointer;
  color: #757575; /* Soft grey */
}

/* Table */
:deep(.v-data-table__wrapper) {
  margin-bottom: 0;
}
.v-table :deep(.v-data-table__th) {
  border-bottom: none !important;
}
.v-table :deep(.v-data-table__thead tr th:first-child) {
  border-radius: 16px 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:last-child) {
  border-radius: 0 16px 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:not(:first-child):not(:last-child)) {
  border-radius: 0 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table-header__content span) {
  font-weight: 600 !important;
}
.v-table :deep(.v-data-table__tbody tr td){
  border-bottom: 1px solid #E1E1E1 !important;
}
.v-table :deep(.v-data-table__tbody tr):hover {
  background: #FFFCFC;
}
.table-cell {
  max-width: 200px;
}
.v-table :deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #872612;
  opacity: 1 !important;
}

.subTitleStyle :deep(.v-toolbar__content) {
  height: auto !important;
}

.subTitleStyle :deep(.v-toolbar-title__placeholder) {
  font-weight: 600 !important;
}

.dialog-card {
  border-radius: 12px !important;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.template-content {
  padding: 24px 32px !important;
  background-color: #fafafa;
}

.template-description {
  margin-bottom: 20px;
}

.alert-content {
  font-size: 0.875rem;
  border-radius: 16px;
  margin-top: 12px;
  padding: 16px 24px;
  background: linear-gradient(45deg, #FFF2F2 0%, #FFFFFF 100%) !important;
  color: rgba(var(--v-theme-on-surface), 0.8);
  border: 1px solid rgba(var(--v-border-color), 0.12);
}

.fileFormatDiv {
  border-radius: 16px;
  margin-top: 32px;
  padding: 16px 24px;
  color: rgba(var(--v-theme-on-surface), 0.8);
  border: 1px solid rgba(var(--v-border-color), 0.12);
}
.file-item {
  height: 112px; 
  width: 122px;
  display: flex; 
  border: 1px solid rgba(var(--v-border-color), 0.12);
  border-radius: 8px;
  padding: 5px;
  flex-direction:column; 
  align-items: center; 
  gap: 8px;
}
.file-icon {
  width: 100%;
  height: 60px;
  background: #EAF9EF;
  border-radius: 8px;
  color: #C32E0E;
  font-size: 24px;
  display: flex; 
  justify-content: center;
  align-items: center;
  box-shadow: none !important;
}

.file-icon img {
  width: 45px;
  height: 45px;
}

.warning-btn {
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 12px;
  background: #a16918;
  color: white !important;
  padding: 12px 0;
  width: 130px;
}

.save-btn-change-password:disabled{
  background: #1976d2;
}

.template-instructions {
  margin: 8px 0 0 16px;
  padding: 0;
}

.template-instructions li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
}

.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.download-cell {
  text-align: center;
  padding: 16px 12px;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  min-width: 100px;
  height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.template-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.close-dialog-action-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 40px;
  padding: 0 24px;
  transition: all 0.2s ease;
}

.close-dialog-action-btn:hover {
  transform: translateY(-1px);
}

/* Animation */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .template-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .template-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 24px;
  }


  .template-content {
    padding: 16px;
  }

  .download-btn {
    font-size: 0.8rem;
    min-width: 90px;
    height: 32px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .download-cell {
    padding: 12px 8px;
  }
}

@media (max-width: 480px) {
  .template-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  .download-btn {
    font-size: 0.75rem;
    min-width: 80px;
    height: 30px;
  }
}

/* Common Dialog Styles */
.template-dialog,
.modern-dialog,
.change-password-dialog { /* NOSONAR */
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
  z-index: 9;
}

/* Common Header Styles */
.template-header,
.dialog-header-success,
.edit-user-header,
.change-password-header {
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header-success {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.edit-user-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.change-password-header {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

/* Common Header Content */


/* Common Content Styles */
.add-user-content,
.edit-user-content,
.change-password-content {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.change-password-content {
  contain: layout;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
  transition: all 0.3s ease;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  padding: 24px;
  border-radius: 16px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 16px;
  padding-bottom: 8px;
}

.section-divider {
  margin: 20px 0;
  opacity: 0.6;
}

.form-row {
  margin-bottom: 8px;
}

.form-row .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Input Styling */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: 60px;
}

.input-wrapper:has(.password-requirements) {
  min-height: 200px;
}

.input-wrapper:has(.password-match) {
  min-height: 120px;
}

.input-label {
  font-size: 0.875rem;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
  font-weight: 400;
}

.modern-input :deep(.v-input__control .v-field--active) {
  padding: 0 !important;
}

.modern-input :deep(.v-field) {
  background: white;
  border-radius: 16px;
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.25;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

.password-toggle {
  margin: 0 !important;
}

/* Password Requirements */
.password-requirements,
.password-match {
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.password-requirements {
  padding: 12px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password-match {
  padding: 8px 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  margin: 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 4px 6px;
  border-radius: 6px;
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInRequirement 0.4s ease-out forwards;
}

.requirement-item:nth-child(1) {
  animation-delay: 0.1s;
}
.requirement-item:nth-child(2) {
  animation-delay: 0.15s;
}
.requirement-item:nth-child(3) {
  animation-delay: 0.2s;
}
.requirement-item:nth-child(4) {
  animation-delay: 0.25s;
}
.requirement-item:nth-child(5) {
  animation-delay: 0.3s;
}

.requirement-item.valid {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
  border-left: 3px solid rgb(var(--v-theme-success));
}

.requirement-item:not(.valid) {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
  border-left: 3px solid rgb(var(--v-theme-error));
}

:deep(.v-autocomplete .v-field__append-inner .v-icon) {
 color: #872612 !important;
}

.switch-div {
  width: 50%;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  border-radius: 16px;
  padding: 16px;
}
.switch-control-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;
  min-height: 100% !important;
}
.switch-content-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.save-btn-edit:disabled {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%) !important;
}
.save-btn-edit:hover,
.save-btn-add:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.modern-input :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}

/* Switch Wrapper */
.switch-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 20px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  border-radius: 12px;
}

.switch-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-success), 0.3) 0%,
    rgba(var(--v-theme-success), 0.1) 100%
  );
  transition: all 0.3s ease;
}

.switch-wrapper:has(.modern-switch input:checked)::before {
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-error), 0.3) 0%,
    rgba(var(--v-theme-error), 0.1) 100%
  );
}

.switch-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.switch-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.lock-icon-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  background: rgba(170, 213, 157, 0.242) !important;
}

.lock-icon-container:has(.locked) {
  background: rgba(244, 67, 54, 0.15) !important;
  background: rgba(156, 61, 61, 0.242) !important;
}

.lock-icon {
  font-size: 24px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.switch-title {
  font-size: 1rem;
  font-weight: 700;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.switch-subtitle {
  font-size: 0.85rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-top: 2px;
  line-height: 1.4;
  max-width: 300px;
  transition: color 0.3s ease;
}

.switch-control {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.modern-switch {
  margin: 0;
}

.modern-switch :deep(.v-selection-control) {
  min-height: auto;
}

.modern-switch :deep(.v-switch__track) {
  background-color: rgba(var(--v-theme-surface-variant), 0.5) !important;
  border: 2px solid rgba(var(--v-border-color), 0.2);
  transition: all 0.3s ease;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: white !important;
  border-color: rgba(var(--v-theme-error));
  border-color: rgba(var(--v-theme-error), 1);
}

:deep(.modern-switch .v-selection-control--dirty .v-switch__thumb) {
  background-color: rgba(var(--v-theme-error)) !important;
}

.switch-label {
  font-size: 0.9rem;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
  font-weight: 600;
}

.switch-label.locked-text {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
}

.switch-label.unlocked-text {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
}

/* Action Buttons */
.add-user-actions,
.edit-user-actions,
.change-password-actions {
  border-top: 1px solid rgba(var(--v-border-color), 0.12) !important;
  padding: 16px 24px;
  gap: 36px !important;
}

.edit-user-actions {
  display: flex;
  align-items: center;
}

.dialog-action-btn,
.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 16px !important;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}

.changePassword-btn {
  color: rgba(var(--v-theme-error)) !important;
  border-color: rgba(var(--v-theme-error)) !important;
}
.changePassword-btn:hover {
  background-color: #FDE4DF !important;
}

.cancel-btn {
  color: #646464 !important;
  border-radius: 16px !important;
  border: 1px solid var(--Border, #949AA8) !important;
}

.dialog-action-btn {
  padding: 0 20px;
  height: 40px;
  min-width: 140px;
}

.dialog-action-btn:hover {
  box-shadow: none !important;
  transform: none !important;
}




/* Responsive Design */
@media (max-width: 768px) {
  .modern-dialog,
  .change-password-dialog { /* NOSONAR */
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .dialog-header-success,
  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .add-user-content,
  .edit-user-content,
  .change-password-content {
    padding: 16px;
    max-height: 60vh;
  }

  .switch-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .switch-control {
    align-items: flex-start;
    width: 100%;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  .dialog-action-btn {
    width: 100%;
    order: 1;
  }

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }
}

@media (max-width: 480px) {
  .modern-dialog,
  .change-password-dialog { /* NOSONAR */
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .add-user-actions,
  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}
/* Common Dialog Styles */
/* Common Header Styles */
/* Common Header Content */



/* Common Content Styles */
.template-content,
.add-user-content,
.edit-user-content,
.change-password-content {
  padding: 24px;
}

/* Form Sections */
/* Input Styling */
.change-password-content .modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
}

.change-password-content
  .modern-input
  :deep(.v-field--focused .v-field__outline) {
  border-color: #ff9800;
}

.help-icon {
  color: rgba(var(--v-theme-primary), 0.7);
  cursor: help;
  transition: color 0.2s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

/* Password Strength Indicator */
.password-strength-wrapper {
  background: white;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.strength-label {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: rgb(var(--v-theme-on-surface));
  transition: all 0.3s ease;
}

.strength-text {
  font-weight: 700;
  margin-left: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.strength-bar {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.strength-bar :deep(.v-progress-linear__background) {
  background-color: rgba(var(--v-border-color), 0.15) !important;
  transition: all 0.3s ease;
}

.strength-bar :deep(.v-progress-linear__determinate) {
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.strength-bar :deep(.v-progress-linear__determinate)::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

/* Role Selection */
.role-selection-container-compact {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.role-radio-group-compact {
  margin: 0;
}

.role-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
}

.role-card-compact {
  position: relative;
  background: #f8f9fa;
  border: 1.5px solid rgba(var(--v-border-color), 0.2);
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.role-card-compact:hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact.selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #e0e0e0 !important;
  border-color: #bdbdbd !important;
}

.role-card-compact.disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  border-color: #bdbdbd !important;
  background: #e0e0e0 !important;
}

.role-badge {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.role-icon-compact {
  font-size: 20px !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.role-radio-compact {
  margin: 0;
  padding: 0;
}

.role-radio-compact :deep(.v-selection-control) {
  min-height: auto;
  margin: 0;
}

.role-radio-compact :deep(.v-selection-control__wrapper) {
  height: 16px;
  width: 16px;
}

.role-details {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
}

.role-title-compact {
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.2;
  text-align: center;
}

.role-chip {
  align-self: center;
  height: 25px !important;
}

/* Role Card Colors */
.role-card-compact:nth-child(1):hover {
  border-color: rgba(244, 67, 54, 0.4);
  background: rgba(244, 67, 54, 0.03);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.12);
}

.role-card-compact:nth-child(1).selected {
  border-color: #f44336;
  background: rgba(244, 67, 54, 0.08);
  box-shadow: 0 2px 12px rgba(244, 67, 54, 0.2);
}

.role-card-compact:nth-child(2):hover {
  border-color: rgba(255, 152, 0, 0.4);
  background: rgba(255, 152, 0, 0.03);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.12);
}

.role-card-compact:nth-child(2).selected {
  border-color: #ff9800;
  background: rgba(255, 152, 0, 0.08);
  box-shadow: 0 2px 12px rgba(255, 152, 0, 0.2);
}

.role-card-compact:nth-child(3):hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact:nth-child(3).selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact:nth-child(4):hover {
  border-color: rgba(156, 39, 176, 0.4);
  background: rgba(156, 39, 176, 0.03);
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.12);
}

.role-card-compact:nth-child(4).selected {
  border-color: #9c27b0;
  background: rgba(156, 39, 176, 0.08);
  box-shadow: 0 2px 12px rgba(156, 39, 176, 0.2);
}

/* Switch Wrapper */
.switch-wrapper:has(.modern-switch input:checked) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-error), 0.1);
}

.switch-wrapper:has(.modern-switch input:not(:checked)) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-success), 0.1);
}

.lock-icon.locked {
  animation: lockShake 0.6s ease-in-out;
  transform-origin: center;
}

.lock-icon.unlocked {
  animation: unlockBounce 0.8s ease-out;
  transform-origin: center;
}

.modern-switch :deep(.bg-error .v-switch__thumb) {
  border-color: rgba(var(--v-theme-error), 1) !important;
}

.modern-switch :deep(.v-switch__thumb) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Security Tips */
.security-tips {
  margin-top: 20px;
  animation: fadeInUp 0.5s ease-out 0.3s both;
}

.security-alert {
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-info), 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.security-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.15);
}

.tips-list {
  margin: 8px 0 0 16px;
  padding: 0;
}

.tips-list li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInTip 0.4s ease-out forwards;
}

.tips-list li:nth-child(1) {
  animation-delay: 0.9s;
}
.tips-list li:nth-child(2) {
  animation-delay: 1s;
}
.tips-list li:nth-child(3) {
  animation-delay: 1.1s;
}
.tips-list li:nth-child(4) {
  animation-delay: 1.2s;
}

/* Action Buttons */
.template-actions,
.add-user-actions,
.edit-user-actions,
.change-password-actions {
  padding: 16px 24px;
  gap: 12px;
}





/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRequirement {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInTip {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes lockShake {
  0%,
  100% {
    transform: translateX(0) scale(1);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-2px) scale(1.05);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(2px) scale(1.05);
  }
}

@keyframes unlockBounce {
  0% {
    transform: scale(1) rotate(0deg);
  }
  20% {
    transform: scale(1.2) rotate(-5deg);
  }
  40% {
    transform: scale(1.1) rotate(5deg);
  }
  60% {
    transform: scale(1.15) rotate(-3deg);
  }
  80% {
    transform: scale(1.05) rotate(2deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}

/* Vue Transitions */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
  filter: blur(2px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px) scale(0.98);
  filter: blur(1px);
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
  filter: blur(0);
}

.expand-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scaleY(0.8);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px) scaleY(0.9);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  max-height: 200px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  /* Dialog sizes */
  .template-dialog,
  .modern-dialog,
  .change-password-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  /* Headers */
  .template-header,
  .dialog-header-success,
  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 24px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  /* Content */
  .template-content,
  .add-user-content,
  .edit-user-content,
  .change-password-content {
    padding: 16px;
  }

  .add-user-content,
  .edit-user-content,
  .change-password-content {
    max-height: 60vh;
  }

  /* Role cards */
  .role-cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .role-card-compact {
    padding: 8px;
    min-height: 60px;
  }

  .role-icon-compact {
    font-size: 18px !important;
  }

  .role-title-compact {
    font-size: 0.8rem;
  }

  /* Switch */
  .switch-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .switch-control {
    align-items: flex-start;
    width: 100%;
  }

  .lock-icon-container {
    width: 40px;
    height: 40px;
  }

  .lock-icon {
    font-size: 20px !important;
  }

  .switch-title {
    font-size: 0.9rem;
  }

  .switch-subtitle {
    font-size: 0.8rem;
    max-width: none;
  }

  /* Password */
  .password-requirements {
    min-height: 100px;
    padding: 10px;
  }

  .password-strength-wrapper {
    min-height: 70px;
    padding: 12px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 180px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 100px;
  }

  .requirement-item {
    font-size: 0.75rem;
    padding: 3px 5px;
    animation-duration: 0.3s;
  }

  .strength-label {
    font-size: 0.8rem;
  }

  /* Buttons */
  .dialog-action-btn,
  .cancel-btn,
  .save-btn {
    min-width: 100px;
    height: 40px;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  .dialog-action-btn {
    width: 100%;
    order: 1;
  }

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }

  /* Template */
  .download-btn {
    font-size: 0.8rem;
    min-width: 90px;
    height: 32px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .download-cell {
    padding: 12px 8px;
  }

  .tips-list {
    font-size: 0.8rem;
  }

  /* Animations */
  .slide-fade-enter-active,
  .expand-fade-enter-active {
    transition-duration: 0.3s;
  }
}

@media (max-width: 480px) {
  /* Dialog sizes */
  .template-dialog,
  .modern-dialog,
  .change-password-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  /* Headers */
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  /* Role cards */
  .role-selection-container-compact {
    padding: 8px;
  }

  .role-cards-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4px;
  }

  .role-card-compact {
    padding: 6px;
    min-height: 55px;
  }

  .role-icon-compact {
    font-size: 16px !important;
  }

  .role-title-compact {
    font-size: 0.75rem;
  }

  /* Switch */
  .switch-wrapper {
    padding: 16px;
  }

  .switch-info {
    gap: 12px;
  }

  .lock-icon-container {
    width: 36px;
    height: 36px;
  }

  .lock-icon {
    font-size: 18px !important;
  }

  .switch-title {
    font-size: 0.85rem;
  }

  .switch-subtitle {
    font-size: 0.75rem;
  }

  .switch-label {
    font-size: 0.8rem;
  }

  /* Password */
  .password-requirements {
    min-height: 90px;
    padding: 8px;
  }

  .password-strength-wrapper {
    min-height: 60px;
    padding: 10px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 160px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 90px;
  }

  /* Buttons */
  .add-user-actions,
  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }

  .dialog-action-btn,
  .cancel-btn,
  .save-btn {
    height: 40px;
    font-size: 0.9rem;
  }

  /* Others */
  .section-title {
    font-size: 1rem;
  }

  .download-btn {
    font-size: 0.75rem;
    min-width: 80px;
    height: 30px;
  }
}

/* Accessibility and Performance */
.role-card-compact:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 1px;
}

.modern-switch:focus-within .lock-icon-container {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.change-password-dialog :deep(.v-btn:focus-visible) {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.switch-wrapper:hover .lock-icon-container {
  transform: scale(1.05);
}

.switch-wrapper:active .lock-icon-container {
  transform: scale(0.95);
}

.switch-wrapper:active .lock-icon {
  transform: scale(0.9);
}

/* Reduce Motion for Accessibility */
@media (prefers-reduced-motion: reduce) {
  .slide-fade-enter-active,
  .slide-fade-leave-active,
  .expand-fade-enter-active,
  .expand-fade-leave-active,
  .requirement-item,
  .strength-bar :deep(.v-progress-linear__determinate),
  .security-tips,
  .tips-list li {
    animation: none;
    transition: none;
  }

  .requirement-item,
  .tips-list li {
    opacity: 1;
    transform: none;
  }
}

/* Hidden/Unused Styles */
.role-selection-container,
.role-radio-group,
.role-card {
  display: none;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.template-btn:hover {
  box-shadow: none !important;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* All Models Selection */
.all-models-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 48px;
}

.all-models-item.selected {
  background: rgba(25, 118, 210, 0.04);
}

.autocomplete-item {
  transition: background 0.2s ease;
  cursor: pointer;
  min-height: 48px;
}

.autocomplete-item:hover, .all-models-item:hover {
  background: #CDD5F3 !important;
}

.model-chip {
  margin: 2px 4px 2px 0 !important;
  font-weight: 500 !important;
  color: #C30000 !important;
}

.user-management-container {
  overflow-x: hidden;
  box-sizing: border-box;
  margin-right: 40px !important;
}

.user-management-container > * {
  max-width: 100%;
  box-sizing: border-box;
}
</style>
